/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("aN+w");
module.exports = __webpack_require__("RQgh");


/***/ }),

/***/ "9a4R":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(undefined);
// imports


// module
exports.push([module.i, ".jw-controlbar .jw-button-container>.jw-icon-playback{display:flex!important}.jw-state-paused .jw-display-icon-container,.jw-state-playing .jw-display-icon-container{display:none}.jwplayer.is-hls .jw-controlbar .jw-button-container>.jw-icon-rewind{display:flex!important}.jw-controlbar .jw-button-container>.jw-icon-rewind{display:none!important}.jwplayer.is-hls .jw-icon-tooltip.jw-icon-volume{display:flex}.jw-controlbar .jw-button-container>.jw-icon-live{display:none}.jwplayer .jw-controlbar .jw-buffer{background-color:hsla(0,0%,100%,.5)!important}.jwplayer.is-hls .jw-volume-tip{padding:13px 0 8px}.jwplayer .jw-text-elapsed{margin-left:12px}.jwplayer .jw-slider-vertical .jw-slider-container{height:68px}.jwplayer .jw-settings-submenu.jw-settings-submenu-active{display:table}\n\n/* !important to override jwplayer breakpoints */.jwplayer .jw-settings-menu{height:auto!important;width:50px!important;bottom:57px!important;right:52px!important;padding:8px 8px 0;flex-direction:row!important}.jwplayer.jw-flag-aspect-mode .jw-settings-menu{width:65px!important;right:45px!important}.jwplayer .jw-settings-submenu{padding:0}.jw-settings-menu .jw-settings-content-item{padding:0;margin-bottom:8px;text-align:center}.jwplayer .jw-settings-open .jw-icon-settings{color:#1bcdcf!important}.jwplayer .jw-settings-topbar{display:none}.jwplayer.jw-flag-small-player .jw-settings-open .jw-controlbar{display:flex}.jwplayer{position:relative}.jwplayer:focus{outline:none}.player_cta{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);padding:20px;background-color:hsla(0,0%,47%,.4);color:#ddd;text-decoration:none;font-family:helvetica,arial,sans-serif;font-size:28px;line-height:30px;letter-spacing:1px;text-align:center}.player_cta:hover{background-color:hsla(0,0%,74%,.4);color:#fff}.jwplayer.jw-state-complete .jw-display-icon-container,.player_qos_tracking_pixel{display:none}.jwplayer .jw-preview{background-size:100% 100%}.jwplayer.jw-flag-live .jw-controlbar .jw-text-alt{visibility:hidden;position:relative;display:block}.jwplayer.jw-flag-live .jw-controlbar .jw-text-alt:after{visibility:visible;position:absolute;top:1px;left:0;content:\"\"}.jwplayer.is-hls .jw-slider-time,.jwplayer.is-hls .jw-text-duration,.jwplayer.is-hls .jw-text-elapsed,.jwplayer.is-hls .jw-tooltip-time{display:none}.jwplayer.is-hls.vod-mode .jw-slider-time,.jwplayer.is-hls.vod-mode .jw-text-duration,.jwplayer.is-hls.vod-mode .jw-text-elapsed,.jwplayer.is-hls.vod-mode .jw-tooltip-time{display:flex}.jwplayer.is-hls .hls-message{position:absolute;left:46%;color:#dadada;font-size:.75em}.aspect-square .jwplayer.is-hls .hls-message{left:42%}.jw-flash-required-message{color:#505050;padding:64px;text-align:center;font-family:ProximaNova,helvetica neue,helvetica,arial,sans-serif;font-weight:400;font-size:15px;line-height:24px}.jw-flash-required-message .jw-flash-header{font-size:27px;line-height:32px;margin-bottom:16px}.jw-flash-required-message .jw-flash-link{color:#fff;text-decoration:none;cursor:pointer}", ""]);

// exports


/***/ }),

/***/ "BBD6":
/***/ (function(module, exports) {

window.jwplayer=function(e){function t(n){if(r[n])return r[n].exports;var i=r[n]={i:n,l:!1,exports:{}};return e[n].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var n=window.webpackJsonpjwplayer;window.webpackJsonpjwplayer=function(t,r,o){for(var a,u,c=0,s=[];c<t.length;c++)u=t[c],i[u]&&s.push(i[u][0]),i[u]=0;for(a in r)Object.prototype.hasOwnProperty.call(r,a)&&(e[a]=r[a]);for(n&&n(t,r,o);s.length;)s.shift()()};var r={},i={15:0};return t.e=function(e){function n(){u.onerror=u.onload=null,clearTimeout(c);var t=i[e];0!==t&&(t&&t[1](new Error("Loading chunk "+e+" failed.")),i[e]=void 0)}var r=i[e];if(0===r)return new Promise(function(e){e()});if(r)return r[2];var o=new Promise(function(t,n){r=i[e]=[t,n]});r[2]=o;var a=document.getElementsByTagName("head")[0],u=document.createElement("script");u.type="text/javascript",u.charset="utf-8",u.async=!0,u.timeout=2e4,t.nc&&u.setAttribute("nonce",t.nc),u.src=t.p+""+({0:"jwplayer.core.controls.polyfills.html5",1:"jwplayer.core.controls.html5",2:"jwplayer.core.controls.polyfills",3:"jwplayer.core.controls",4:"jwplayer.controls",5:"provider.shaka",6:"provider.hlsjs",7:"provider.html5",8:"jwplayer.core",9:"provider.flash",10:"polyfills.intersection-observer",11:"provider.cast",12:"vttparser",13:"provider.airplay",14:"polyfills.webvtt"}[e]||e)+".js";var c=setTimeout(n,2e4);return u.onerror=u.onload=n,a.appendChild(u),o},t.m=e,t.c=r,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t.oe=function(e){throw console.error(e),e},t(t.s=54)}([function(e,t,n){"use strict";var r=n(33),i={},o=Array.prototype,a=Object.prototype,u=Function.prototype,c=o.slice,s=o.concat,l=a.toString,f=a.hasOwnProperty,d=o.map,p=o.reduce,v=o.forEach,h=o.filter,m=o.every,g=o.some,y=o.indexOf,b=Array.isArray,w=Object.keys,j=u.bind,O=function e(t){return t instanceof e?t:this instanceof e?void 0:new e(t)},k=O.each=O.forEach=function(e,t,n){var r,o;if(null==e)return e;if(v&&e.forEach===v)e.forEach(t,n);else if(e.length===+e.length){for(r=0,o=e.length;r<o;r++)if(t.call(n,e[r],r,e)===i)return}else{var a=O.keys(e);for(r=0,o=a.length;r<o;r++)if(t.call(n,e[a[r]],a[r],e)===i)return}return e};O.map=O.collect=function(e,t,n){var r=[];return null==e?r:d&&e.map===d?e.map(t,n):(k(e,function(e,i,o){r.push(t.call(n,e,i,o))}),r)};O.reduce=O.foldl=O.inject=function(e,t,n,r){var i=arguments.length>2;if(null==e&&(e=[]),p&&e.reduce===p)return r&&(t=O.bind(t,r)),i?e.reduce(t,n):e.reduce(t);if(k(e,function(e,o,a){i?n=t.call(r,n,e,o,a):(n=e,i=!0)}),!i)throw new TypeError("Reduce of empty array with no initial value");return n},O.find=O.detect=function(e,t,n){var r;return C(e,function(e,i,o){if(t.call(n,e,i,o))return r=e,!0}),r},O.filter=O.select=function(e,t,n){var r=[];return null==e?r:h&&e.filter===h?e.filter(t,n):(k(e,function(e,i,o){t.call(n,e,i,o)&&r.push(e)}),r)},O.reject=function(e,t,n){return O.filter(e,function(e,r,i){return!t.call(n,e,r,i)},n)},O.compact=function(e){return O.filter(e,O.identity)},O.every=O.all=function(e,t,n){t||(t=O.identity);var r=!0;return null==e?r:m&&e.every===m?e.every(t,n):(k(e,function(e,o,a){if(!(r=r&&t.call(n,e,o,a)))return i}),!!r)};var C=O.some=O.any=function(e,t,n){t||(t=O.identity);var r=!1;return null==e?r:g&&e.some===g?e.some(t,n):(k(e,function(e,o,a){if(r||(r=t.call(n,e,o,a)))return i}),!!r)};O.size=function(e){return null==e?0:e.length===+e.length?e.length:O.keys(e).length},O.last=function(e,t,n){if(null!=e)return null==t||n?e[e.length-1]:c.call(e,Math.max(e.length-t,0))},O.after=function(e,t){return function(){if(--e<1)return t.apply(this,arguments)}},O.before=function(e,t){var n;return function(){return--e>0&&(n=t.apply(this,arguments)),e<=1&&(t=null),n}};var x=function(e){return null==e?O.identity:O.isFunction(e)?e:O.property(e)},P=function(e){return function(t,n,r){var i={};return n=x(n),k(t,function(o,a){var u=n.call(r,o,a,t);e(i,u,o)}),i}};O.groupBy=P(function(e,t,n){O.has(e,t)?e[t].push(n):e[t]=[n]}),O.indexBy=P(function(e,t,n){e[t]=n}),O.sortedIndex=function(e,t,n,r){n=x(n);for(var i=n.call(r,t),o=0,a=e.length;o<a;){var u=o+a>>>1;n.call(r,e[u])<i?o=u+1:a=u}return o},O.contains=O.include=function(e,t){return null!=e&&(e.length!==+e.length&&(e=O.values(e)),O.indexOf(e,t)>=0)},O.pluck=function(e,t){return O.map(e,O.property(t))},O.where=function(e,t){return O.filter(e,O.matches(t))},O.findWhere=function(e,t){return O.find(e,O.matches(t))},O.max=function(e,t,n){if(!t&&O.isArray(e)&&e[0]===+e[0]&&e.length<65535)return Math.max.apply(Math,e);var r=-1/0,i=-1/0;return k(e,function(e,o,a){var u=t?t.call(n,e,o,a):e;u>i&&(r=e,i=u)}),r},O.difference=function(e){var t=s.apply(o,c.call(arguments,1));return O.filter(e,function(e){return!O.contains(t,e)})},O.without=function(e){return O.difference(e,c.call(arguments,1))},O.indexOf=function(e,t,n){if(null==e)return-1;var r=0,i=e.length;if(n){if("number"!=typeof n)return r=O.sortedIndex(e,t),e[r]===t?r:-1;r=n<0?Math.max(0,i+n):n}if(y&&e.indexOf===y)return e.indexOf(t,n);for(;r<i;r++)if(e[r]===t)return r;return-1};var E=function(){};O.bind=function(e,t){var n,r;if(j&&e.bind===j)return j.apply(e,c.call(arguments,1));if(!O.isFunction(e))throw new TypeError;return n=c.call(arguments,2),r=function(){if(!(this instanceof r))return e.apply(t,n.concat(c.call(arguments)));E.prototype=e.prototype;var i=new E;E.prototype=null;var o=e.apply(i,n.concat(c.call(arguments)));return Object(o)===o?o:i}},O.partial=function(e){var t=c.call(arguments,1);return function(){for(var n=0,r=t.slice(),i=0,o=r.length;i<o;i++)r[i]===O&&(r[i]=arguments[n++]);for(;n<arguments.length;)r.push(arguments[n++]);return e.apply(this,r)}},O.once=O.partial(O.before,2),O.memoize=function(e,t){var n={};return t||(t=O.identity),function(){var r=t.apply(this,arguments);return O.has(n,r)?n[r]:n[r]=e.apply(this,arguments)}},O.delay=function(e,t){var n=c.call(arguments,2);return setTimeout(function(){return e.apply(null,n)},t)},O.defer=function(e){return O.delay.apply(O,[e,1].concat(c.call(arguments,1)))},O.throttle=function(e,t,n){var i,o,a,u=null,c=0;n||(n={});var s=function(){c=!1===n.leading?0:Object(r.a)(),u=null,a=e.apply(i,o),i=o=null};return function(){c||!1!==n.leading||(c=r.a);var l=t-(r.a-c);return i=this,o=arguments,l<=0?(clearTimeout(u),u=null,c=r.a,a=e.apply(i,o),i=o=null):u||!1===n.trailing||(u=setTimeout(s,l)),a}},O.keys=function(e){if(!O.isObject(e))return[];if(w)return w(e);var t=[];for(var n in e)O.has(e,n)&&t.push(n);return t},O.invert=function(e){for(var t={},n=O.keys(e),r=0,i=n.length;r<i;r++)t[e[n[r]]]=n[r];return t},O.defaults=function(e){return k(c.call(arguments,1),function(t){if(t)for(var n in t)void 0===e[n]&&(e[n]=t[n])}),e},O.extend=function(e){return k(c.call(arguments,1),function(t){if(t)for(var n in t)e[n]=t[n]}),e},O.pick=function(e){var t={},n=s.apply(o,c.call(arguments,1));return k(n,function(n){n in e&&(t[n]=e[n])}),t},O.omit=function(e){var t={},n=s.apply(o,c.call(arguments,1));for(var r in e)O.contains(n,r)||(t[r]=e[r]);return t},O.clone=function(e){return O.isObject(e)?O.isArray(e)?e.slice():O.extend({},e):e},O.isArray=b||function(e){return"[object Array]"==l.call(e)},O.isObject=function(e){return e===Object(e)},k(["Function","String","Number","Date","RegExp"],function(e){O["is"+e]=function(t){return l.call(t)=="[object "+e+"]"}}),O.isFunction=function(e){return"function"==typeof e},O.isFinite=function(e){return isFinite(e)&&!isNaN(parseFloat(e))},O.isNaN=function(e){return O.isNumber(e)&&e!=+e},O.isBoolean=function(e){return!0===e||!1===e||"[object Boolean]"==l.call(e)},O.isNull=function(e){return null===e},O.isUndefined=function(e){return void 0===e},O.has=function(e,t){return f.call(e,t)},O.identity=function(e){return e},O.constant=function(e){return function(){return e}},O.property=function(e){return function(t){return t[e]}},O.propertyOf=function(e){return null==e?function(){}:function(t){return e[t]}},O.matches=function(e){return function(t){if(t===e)return!0;for(var n in e)if(e[n]!==t[n])return!1;return!0}},O.now=r.a,O.result=function(e,t){if(null!=e){var n=e[t];return O.isFunction(n)?n.call(e):n}},t.a=O},function(e,t,n){"use strict";function r(e){return e.replace(/^\s+|\s+$/g,"")}function i(e,t,n){for(e=""+e,n=n||"0";e.length<t;)e=n+e;return e}function o(e,t){for(var n=0;n<e.attributes.length;n++)if(e.attributes[n].name&&e.attributes[n].name.toLowerCase()===t.toLowerCase())return e.attributes[n].value.toString();return""}function a(e){return/[(,]format=m3u8-/i.test(e)?"m3u8":!!/[(,]format=mpd-/i.test(e)&&"mpd"}function u(e){if(!e||"rtmp"===e.substr(0,4))return"";var t=a(e);return t||(e=e.split("?")[0].split("#")[0],e.lastIndexOf(".")>-1?e.substr(e.lastIndexOf(".")+1,e.length).toLowerCase():void 0)}function c(e){var t=parseInt(e/3600),n=parseInt(e/60)%60,r=e%60;return i(t,2)+":"+i(n,2)+":"+i(r.toFixed(3),6)}function s(e,t){if(!e)return 0;if(d.a.isNumber(e)&&!d.a.isNaN(e))return e;e=e.replace(",",".");var n=e.split(":"),r=n.length,i=0;if("s"===e.slice(-1))i=parseFloat(e);else if("m"===e.slice(-1))i=60*parseFloat(e);else if("h"===e.slice(-1))i=3600*parseFloat(e);else if(r>1){var o=r-1;4===r&&(t&&(i=parseFloat(n[o])/t),o-=1),i+=parseFloat(n[o]),i+=60*parseFloat(n[o-1]),r>=3&&(i+=3600*parseFloat(n[o-2]))}else i=parseFloat(e);return d.a.isNaN(i)?0:i}function l(e,t){return d.a.map(e,function(e){return t+e})}function f(e,t){return d.a.map(e,function(e){return e+t})}t.g=r,t.c=i,t.h=o,t.a=u,t.b=c,t.e=s,t.d=l,t.f=f;var d=n(0)},,,function(e,t,n){"use strict";n.d(t,"_0",function(){return r}),n.d(t,"_3",function(){return i}),n.d(t,"_1",function(){return o}),n.d(t,"_5",function(){return a}),n.d(t,"_6",function(){return u}),n.d(t,"_2",function(){return c}),n.d(t,"_4",function(){return s}),n.d(t,"_7",function(){return l}),n.d(t,"m",function(){return f}),n.d(t,"o",function(){return d}),n.d(t,"n",function(){return p}),n.d(t,"h",function(){return v}),n.d(t,"k",function(){return h}),n.d(t,"_8",function(){return m}),n.d(t,"l",function(){return g}),n.d(t,"P",function(){return y}),n.d(t,"N",function(){return b}),n.d(t,"p",function(){return w}),n.d(t,"O",function(){return j}),n.d(t,"q",function(){return O}),n.d(t,"a",function(){return k}),n.d(t,"y",function(){return C}),n.d(t,"X",function(){return x}),n.d(t,"I",function(){return P}),n.d(t,"v",function(){return E}),n.d(t,"u",function(){return S}),n.d(t,"x",function(){return T}),n.d(t,"j",function(){return _}),n.d(t,"S",function(){return M}),n.d(t,"g",function(){return N}),n.d(t,"z",function(){return L}),n.d(t,"A",function(){return A}),n.d(t,"F",function(){return F}),n.d(t,"G",function(){return I}),n.d(t,"J",function(){return R}),n.d(t,"Z",function(){return B}),n.d(t,"R",function(){return q}),n.d(t,"w",function(){return D}),n.d(t,"K",function(){return X}),n.d(t,"H",function(){return Q}),n.d(t,"L",function(){return z}),n.d(t,"M",function(){return V}),n.d(t,"E",function(){return H}),n.d(t,"D",function(){return W}),n.d(t,"B",function(){return U}),n.d(t,"C",function(){return J}),n.d(t,"i",function(){return $}),n.d(t,"r",function(){return K}),n.d(t,"Y",function(){return Y}),n.d(t,"T",function(){return G}),n.d(t,"U",function(){return Z}),n.d(t,"b",function(){return ee}),n.d(t,"c",function(){return te}),n.d(t,"Q",function(){return ne}),n.d(t,"t",function(){return re}),n.d(t,"f",function(){return ie}),n.d(t,"e",function(){return oe}),n.d(t,"V",function(){return ae}),n.d(t,"W",function(){return ue}),n.d(t,"_9",function(){return ce}),n.d(t,"s",function(){return se}),n.d(t,"d",function(){return le});var r="buffering",i="idle",o="complete",a="paused",u="playing",c="error",s="loading",l="stalled",f="drag",d="dragStart",p="dragEnd",v="click",h="doubleClick",m="tap",g="doubleTap",y="over",b="move",w="enter",j="out",O=c,k="adSkipped",C=o,x="ready",P="seek",E="beforePlay",S="beforeComplete",T="bufferFull",_="displayClick",M="playlistComplete",N="cast",L="mediaError",A="firstFrame",F="playAttempt",I="playAttemptFailed",R="seeked",B="setupError",q="state",D="bufferChange",X="time",Q="ratechange",z="mediaType",V="volume",H="mute",W="meta",U="levels",J="levelsChanged",$="controls",K="fullscreen",Y="resize",G="playlistItem",Z="playlist",ee="audioTracks",te="audioTrackChanged",ne="playbackRateChanged",re="logoClick",ie="captionsList",oe="captionsChanged",ae="providerChanged",ue="providerFirstFrame",ce="userAction",se="instreamClick",le="breakpoint"},function(e,t,n){"use strict";function r(){}function i(e,t){return function(){e.apply(t,arguments)}}function o(e){if("object"!==d(this))throw new TypeError("Promises must be constructed via new");if("function"!=typeof e)throw new TypeError("not a function");this._state=0,this._handled=!1,this._value=void 0,this._deferreds=[],f(e,this)}function a(e,t){for(;3===e._state;)e=e._value;if(0===e._state)return void e._deferreds.push(t);e._handled=!0,o._immediateFn(function(){var n=1===e._state?t.onFulfilled:t.onRejected;if(null===n)return void(1===e._state?u:c)(t.promise,e._value);var r;try{r=n(e._value)}catch(e){return void c(t.promise,e)}u(t.promise,r)})}function u(e,t){try{if(t===e)throw new TypeError("A promise cannot be resolved with itself.");if(t&&("object"===(void 0===t?"undefined":d(t))||"function"==typeof t)){var n=t.then;if(t instanceof o)return e._state=3,e._value=t,void s(e);if("function"==typeof n)return void f(i(n,t),e)}e._state=1,e._value=t,s(e)}catch(t){c(e,t)}}function c(e,t){e._state=2,e._value=t,s(e)}function s(e){2===e._state&&0===e._deferreds.length&&o._immediateFn(function(){e._handled||o._unhandledRejectionFn(e._value)});for(var t=0,n=e._deferreds.length;t<n;t++)a(e,e._deferreds[t]);e._deferreds=null}function l(e,t,n){this.onFulfilled="function"==typeof e?e:null,this.onRejected="function"==typeof t?t:null,this.promise=n}function f(e,t){var n=!1;try{e(function(e){n||(n=!0,u(t,e))},function(e){n||(n=!0,c(t,e))})}catch(e){if(n)return;n=!0,c(t,e)}}n.d(t,"b",function(){return m});var d="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},p=window.setTimeout,v=window.setImmediate;o.prototype.catch=function(e){return this.then(null,e)},o.prototype.then=function(e,t){var n=new this.constructor(r);return a(this,new l(e,t,n)),n},o.all=function(e){var t=Array.prototype.slice.call(e);return new o(function(e,n){function r(o,a){try{if(a&&("object"===(void 0===a?"undefined":d(a))||"function"==typeof a)){var u=a.then;if("function"==typeof u)return void u.call(a,function(e){r(o,e)},n)}t[o]=a,0==--i&&e(t)}catch(e){n(e)}}if(0===t.length)return e([]);for(var i=t.length,o=0;o<t.length;o++)r(o,t[o])})},o.resolve=function(e){return e&&"object"===(void 0===e?"undefined":d(e))&&e.constructor===o?e:new o(function(t){t(e)})},o.reject=function(e){return new o(function(t,n){n(e)})},o.race=function(e){return new o(function(t,n){for(var r=0,i=e.length;r<i;r++)e[r].then(t,n)})},o._immediateFn="function"==typeof v&&function(e){v(e)}||function(e){p(e,0)},o._unhandledRejectionFn=function(e){"undefined"!=typeof console&&console&&console.warn("Possible Unhandled Promise Rejection:",e)};var h=window.Promise||(window.Promise=o),m=h.resolve();t.a=h},function(e,t,n){"use strict";function r(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:[];if(l.a.debug)return e.apply(t||this,n);try{return e.apply(t||this,n)}catch(t){return new i(e.name,t)}}function i(e,t){this.name=e,this.message=t.message||t.toString(),this.error=t}Object.defineProperty(t,"__esModule",{value:!0});var o=n(16),a=n(12),u=n(13),c=n(1),s=n(21),l=n(19),f=n(0),d=n(29),p=n(25),v=n(26),h=n(52);n.d(t,"b",function(){return g});var m=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},g="function"==typeof console.log?console.log.bind(console):function(){},y=function(e,t,n){return Math.max(Math.min(e,n),t)},b=function(e,t){for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&t(n,e[n])},w=f.a.indexOf,j=function(){},O=m({},u,a,o,{addClass:p.a,hasClass:p.h,removeClass:p.j,replaceClass:p.k,toggleClass:p.m,classList:p.d,styleDimension:p.l,createElement:p.e,emptyElement:p.g,addStyleSheet:p.b,bounds:p.c,css:v.b,clearCss:v.a,style:v.d,transform:v.e,getRgba:v.c,ajax:h.a,crossdomain:h.b,tryCatch:r,Error:i,Timer:s.a,log:g,between:y,foreach:b,flashVersion:d.a,isIframe:d.m,indexOf:w,trim:c.g,pad:c.c,extension:c.a,hms:c.b,seconds:c.e,prefix:c.d,suffix:c.f,noop:j});t.a=O},function(e,t,n){"use strict";function r(e,t,n){if(!c(this,"on",e,[t,n])||!t)return this;var r=this._events||(this._events={});return(r[e]||(r[e]=[])).push({callback:t,context:n}),this}function i(e,t,n){if(!c(this,"once",e,[t,n])||!t)return this;var r=0,i=this,o=function n(){r++||(i.off(e,n),t.apply(this,arguments))};return o._callback=t,this.on(e,o,n)}function o(e,t,n){if(!this._events||!c(this,"off",e,[t,n]))return this;if(!e&&!t&&!n)return delete this._events,this;for(var r=e?[e]:Object.keys(this._events),i=0,o=r.length;i<o;i++){e=r[i];var a=this._events[e];if(a){var u=this._events[e]=[];if(t||n)for(var s=0,l=a.length;s<l;s++){var f=a[s];(t&&t!==f.callback&&t!==f.callback._callback||n&&n!==f.context)&&u.push(f)}u.length||delete this._events[e]}}return this}function a(e){if(!this._events)return this;var t=f.call(arguments,1);if(!c(this,"trigger",e,t))return this;var n=this._events[e],r=this._events.all;return n&&s(n,t,this),r&&s(r,arguments,this),this}function u(e){if(!this._events)return this;var t=f.call(arguments,1);if(!c(this,"trigger",e,t))return this;var n=this._events[e],r=this._events.all;return n&&s(n,t,this,e),r&&s(r,arguments,this,e),this}function c(e,t,n,r){if(!n)return!0;if("object"===(void 0===n?"undefined":l(n))){for(var i in n)Object.prototype.hasOwnProperty.call(n,i)&&e[t].apply(e,[i,n[i]].concat(r));return!1}if(d.test(n)){for(var o=n.split(d),a=0,u=o.length;a<u;a++)e[t].apply(e,[o[a]].concat(r));return!1}return!0}function s(e,t,n,r){for(var i=-1,o=e.length;++i<o;){var a=e[i];if(r)try{a.callback.apply(a.context||n,t)}catch(e){console.log('Error in "'+r+'" event handler:',e)}else a.callback.apply(a.context||n,t)}}t.c=r,t.d=i,t.b=o,t.e=a,t.f=u;var l="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},f=[].slice,d=/\s+/;t.a={on:r,once:i,off:o,trigger:a}},function(e,t,n){"use strict";function r(e){return b||(b=o(e)),b}function i(){throw new Error("Network error")}function o(e){var t=e.get("controls"),n=a(),r=u(e,"html5");return t&&n&&r?c():t&&r?s():t&&n?l():t?f():d()}function a(){var e=window.IntersectionObserverEntry;return!(e&&"IntersectionObserver"in window&&"intersectionRatio"in e.prototype)}function u(e,t){var n=e.get("playlist");if(Array.isArray(n)&&n.length)for(var r=Object(v.a)(n[0]).sources,i=0;i<r.length;i++)for(var o=r[i],a=e.getProviders(),u=0;u<h.a.length;u++){var c=h.a[u];if(a.providerSupports(c,o))return c.name===t}return!1}function c(){return w.html5=!0,n.e(0).then(function(e){n(9);var t=n(3).default;return g.b.controls=n(2).default,Object(m.a)(n(11).default),t}.bind(null,n)).catch(i)}function s(){return w.html5=!0,n.e(1).then(function(e){var t=n(3).default;return g.b.controls=n(2).default,Object(m.a)(n(11).default),t}.bind(null,n)).catch(i)}function l(){return n.e(2).then(function(e){n(9);var t=n(3).default;return g.b.controls=n(2).default,t}.bind(null,n)).catch(i)}function f(){return n.e(3).then(function(e){var t=n(3).default;return g.b.controls=n(2).default,t}.bind(null,n)).catch(i)}function d(){return p().then(function(){return n.e(8).then(function(e){return n(3).default}.bind(null,n)).catch(i)})}function p(){return a()?n.e(10).then(function(e){return n(9)}.bind(null,n)).catch(i):y.b}n.d(t,"a",function(){return w}),t.c=r,t.b=i;var v=n(24),h=n(17),m=n(18),g=n(47),y=n(5),b=null,w={}},,function(e,t,n){"use strict";function r(e){var t="";return e&&(e.localName?t=e.localName:e.baseName&&(t=e.baseName)),t}function i(e){var t="";return e&&(e.textContent?t=Object(u.g)(e.textContent):e.text&&(t=Object(u.g)(e.text))),t}function o(e,t){return e.childNodes[t]}function a(e){return e.childNodes?e.childNodes.length:0}t.b=r,t.d=i,t.a=o,t.c=a;var u=n(1)},,function(e,t,n){"use strict";function r(e){switch(void 0===e?"undefined":c(e)){case"string":return e.length>0;case"object":return null!==e;case"undefined":return!1;default:return!0}}function i(){return"https:"===window.location.protocol}function o(e,t){return 0===e.indexOf("rtmp:")||"rtmp"===t}function a(e,t){return"youtube"===t||/^(http|\/\/).*(youtube\.com|youtu\.be)\/.+/.test(e)}function u(e){if(null===e)return"null";var t=void 0===e?"undefined":c(e);return"object"===t&&Array.isArray(e)?"array":t}Object.defineProperty(t,"__esModule",{value:!0}),t.exists=r,t.isHTTPS=i,t.isRtmp=o,t.isYouTube=a,t.typeOf=u;var c="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e}},function(e,t,n){"use strict";function r(e,t){if(Object(l.exists)(t)||(t=document.location.href),Object(l.exists)(e)){if(i(e))return e;var n=t.substring(0,t.indexOf("://")+3),r=t.substring(n.length,t.indexOf("/",n.length+1)),o=void 0;if(0===e.indexOf("/"))o=e.split("/");else{var a=t.split("?")[0];a=a.substring(n.length+r.length+1,a.lastIndexOf("/")),o=a.split("/").concat(e.split("/"))}for(var u=[],c=0;c<o.length;c++)o[c]&&Object(l.exists)(o[c])&&"."!==o[c]&&(".."===o[c]?u.pop():u.push(o[c]));return n+r+"/"+u.join("/")}}function i(e){return/^(?:(?:https?|file):)?\/\//.test(e)}function o(e){return f.a.some(e,function(e){return"parsererror"===e.nodeName})}function a(e){var t=null;try{"DOMParser"in window?(t=(new window.DOMParser).parseFromString(e,"text/xml"),(o(t.childNodes)||t.childNodes&&o(t.childNodes[0].childNodes))&&(t=null)):(t=new window.ActiveXObject("Microsoft.XMLDOM"),t.async="false",t.loadXML(e))}catch(e){}return t}function u(e){if(void 0===e)return null;if("string"==typeof e&&e.length<6){var t=e.toLowerCase();if("true"===t)return!0;if("false"===t)return!1;if(!isNaN(Number(e))&&!isNaN(parseFloat(e)))return Number(e)}return e}function c(e){return"string"==typeof e?""===e?0:e.lastIndexOf("%")>-1?e:parseInt(e.replace("px",""),10):e}function s(e,t){if(e<=0&&!t||f.a.isNaN(parseInt(e)))return"00:00";var n=e<0?"-":"";e=Math.abs(e);var r=Math.floor(e/3600),i=Math.floor((e-3600*r)/60),o=Math.floor(e%60);return n+(r?r+":":"")+(i<10?"0":"")+i+":"+(o<10?"0":"")+o}Object.defineProperty(t,"__esModule",{value:!0}),t.getAbsolutePath=r,t.isAbsolutePath=i,t.parseXML=a,t.serialize=u,t.parseDimension=c,t.timeFormat=s;var l=n(12),f=n(0)},function(e,t,n){"use strict";function r(e,t){var n=void 0,r=void 0,i=void 0,o=void 0;return e.chrome?n=-1!==t.indexOf("Chrome")?t.substring(t.indexOf("Chrome")+7):t.substring(t.indexOf("CriOS")+6):e.safari?n=t.substring(t.indexOf("Version")+8):e.firefox?n=t.substring(t.indexOf("Firefox")+8):e.edge?n=t.substring(t.indexOf("Edge")+5):e.ie&&(-1!==t.indexOf("rv:")?n=t.substring(t.indexOf("rv:")+3):-1!==t.indexOf("MSIE")&&(n=t.substring(t.indexOf("MSIE")+5))),n&&(-1!==(o=n.indexOf(";"))&&(n=n.substring(0,o)),-1!==(o=n.indexOf(" "))&&(n=n.substring(0,o)),-1!==(o=n.indexOf(")"))&&(n=n.substring(0,o)),r=parseInt(n,10),i=parseInt(n.split(".")[1],10)),{version:n,major:r,minor:i}}function i(e,t){if(e&&e.length>t)return e[t]}function o(e,t){var n=void 0,r=void 0,o=void 0;if(e.windows)switch(n=i(/Windows(?: NT|)? ([._\d]+)/.exec(t),1)){case"6.1":n="7.0";break;case"6.2":n="8.0";break;case"6.3":n="8.1"}else e.android?n=i(/Android ([._\d]+)/.exec(t),1):e.iOS?n=i(/OS ([._\d]+)/.exec(t),1):e.mac&&(n=i(/Mac OS X (10[._\d]+)/.exec(t),1));if(n){r=parseInt(n,10);var a=n.split(/[._]/);a&&(o=parseInt(a[1],10))}return{version:n,major:r,minor:o}}Object.defineProperty(t,"__esModule",{value:!0});var a=n(29),u=n(0);n.d(t,"Browser",function(){return l}),n.d(t,"OS",function(){return f}),n.d(t,"Features",function(){return d});var c=u.a.memoize,s=navigator.userAgent,l={},f={},d={},p=function(){return s.indexOf("Windows")>-1};Object.defineProperties(l,{androidNative:{get:c(a.c),enumerable:!0},chrome:{get:c(a.d),enumerable:!0},edge:{get:c(a.e),enumerable:!0},facebook:{get:c(a.g),enumerable:!0},firefox:{get:c(a.f),enumerable:!0},ie:{get:c(a.i),enumerable:!0},msie:{get:c(a.n),enumerable:!0},safari:{get:c(a.q),enumerable:!0},version:{get:c(r.bind(this,l,s)),enumerable:!0}}),Object.defineProperties(f,{android:{get:c(a.b),enumerable:!0},iOS:{get:c(a.j),enumerable:!0},mobile:{get:c(a.o),enumerable:!0},mac:{get:c(a.p),enumerable:!0},iPad:{get:c(a.k),enumerable:!0},iPhone:{get:c(a.l),enumerable:!0},windows:{get:c(p),enumerable:!0},version:{get:c(o.bind(this,f,s)),enumerable:!0}}),Object.defineProperties(d,{flash:{get:c(a.h),enumerable:!0},flashVersion:{get:c(a.a),enumerable:!0},iframe:{get:c(a.m),enumerable:!0}})},function(e,t,n){"use strict";function r(e){var t={setup:[i,o,a,u,c,l,f,d,s],drm:[c,l,f,d],ads:[l,f,d,s,c],jwpsrv:[i,o,a,u,c,l,d,s],discovery:[l,c,d,f]};return function(n){return t[n]&&t[n].indexOf(e)>-1}}t.a=r;var i="free",o="starter",a="business",u="premium",c="enterprise",s="platinum",l="ads",f="unlimited",d="trial"},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),n.d(t,"getScriptPath",function(){return i}),n.d(t,"repo",function(){return o}),n.d(t,"versionCheck",function(){return a}),n.d(t,"loadFrom",function(){return u});var r=n(20),i=function(e){for(var t=document.getElementsByTagName("script"),n=0;n<t.length;n++){var r=t[n].src;if(r){var i=r.lastIndexOf("/"+e);if(i>=0)return r.substr(0,i+1)}}return""},o=function(){var e="//ssl.p.jwpcdn.com/player/v/8.0.10/";return("file:"===window.location.protocol?"https:":"")+e},a=function(e){var t=("0"+e).split(/\W/),n=r.a.split(/\W/),i=parseFloat(t[0]),o=parseFloat(n[0]);return!(i>o)&&!(i===o&&parseFloat("0"+t[1])>parseFloat(n[1]))},u=function(){return o()}},function(e,t,n){"use strict";function r(){return!!window.MediaSource&&!!window.MediaSource.isTypeSupported&&window.MediaSource.isTypeSupported('video/mp4;codecs="avc1.4d400d,mp4a.40.2"')}function i(e){if(f.Browser.safari)return!1;if(e.drm&&!Object(v.a)(e.drm))return!1;var t=window.MediaSource;if(!window.HTMLVideoElement||!t)return!1;var n=!0;return e.mediaTypes&&(n=p.a.all(e.mediaTypes,function(e){return t.isTypeSupported(e)})),n&&("dash"===e.type||"mpd"===e.type||(e.file||"").indexOf("mpd-time-csf")>-1)}Object.defineProperty(t,"__esModule",{value:!0});var o=n(53),a=n(12),u=n(34),c={aac:"audio/mp4",mp4:"video/mp4",f4v:"video/mp4",m4v:"video/mp4",mov:"video/mp4",mp3:"audio/mpeg",mpeg:"audio/mpeg",ogv:"video/ogg",ogg:"video/ogg",oga:"video/ogg",vorbis:"video/ogg",webm:"video/webm",f4a:"video/aac",m3u8:"application/vnd.apple.mpegurl",m3u:"application/vnd.apple.mpegurl",hls:"application/vnd.apple.mpegurl"},s=[{name:"html5",supports:function(e){if(!1===Object(o.a)(e))return!1;if(!u.a.canPlayType)return!1;var t=e.file,n=e.type;if(Object(a.isRtmp)(t,n))return!1;var r=e.mimeType||c[n];return!!r&&!!u.a.canPlayType(r)}}],l=s,f=n(14),d=n(15),p=n(0),v=n(28),h=p.a.find(l,p.a.matches({name:"html5"})),m=h.supports;h.supports=function(e,t){var n=m.apply(this,arguments);if(n&&e.drm&&"hls"===e.type){var r=Object(d.a)(t),i=r("drm");if(i&&e.drm.fairplay){var o=window.WebKitMediaKeys;return o&&o.isTypeSupported&&o.isTypeSupported("com.apple.fps.1_0","video/mp4")}return i}return n},l.push({name:"shaka",supports:i}),l.splice(0,0,{name:"hlsjs",supports:function(e){if(e.drm)return!1;var t=f.Browser.chrome||f.Browser.firefox||f.Browser.edge||f.Browser.ie&&11===f.Browser.version.major,n=f.OS.android&&!!e.hlsjsdefault,i=!f.OS.iOS&&f.Browser.safari&&!!e.safarihlsjs,o=r()&&(t||n||i),a=e.file.indexOf(".m3u8")>-1,u="hls"===e.type||"m3u8"===e.type;return o&&(a||u)}}),l.push({name:"flash",supports:function(e){if(!f.Features.flash||e.drm)return!1;var t=e.type;return"hls"===t||"m3u8"===t||!Object(a.isRtmp)(e.file,t)&&["flv","f4v","mov","m4a","m4v","mp4","aac","f4a","mp3","mpeg","smil"].indexOf(t)>-1}});t.a=l},function(e,t,n){"use strict";function r(e){var t=e.getName().name;if(!i.a[t]){if(!u.a.find(o.a,u.a.matches({name:t}))){if(!u.a.isFunction(e.supports))throw new Error("Tried to register a provider with an invalid object");o.a.unshift({name:t,supports:e.supports})}u.a.defaults(e.prototype,a.a),i.a[t]=e}}t.a=r;var i=n(35),o=n(17),a=n(44),u=n(0)},function(e,t,n){"use strict";t.a={debug:!1}},function(e,t,n){"use strict";n.d(t,"a",function(){return r});var r="8.0.10+commercial_v8-0-10.220.commercial.f0e723.hlsjs..jwplayer.2df85c.dai.c13f11.freewheel.01885d.googima.534335.vast.5ded3a.jwpsrv.32f990.gapro.692829.related.eac442.vr.2cfb26"},function(e,t,n){"use strict";function r(){return a+o.now()}Object.defineProperty(t,"__esModule",{value:!0});var i=window.Date,o=window.performance||{timing:{}},a=o.timing.navigationStart||(new i).getTime();"now"in o||(o.now=function(){return(new i).getTime()-a});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},c=function(){var e={},t={},n={},i={};return{start:function(t){e[t]=r(),n[t]=n[t]+1||1},end:function(n){if(e[n]){var i=r(),o=i-e[n];delete e[n],t[n]=t[n]+o||o}},dump:function(){var o=u({},t);for(var a in e)if(Object.prototype.hasOwnProperty.call(e,a)){var c=r(),s=c-e[a];o[a]=o[a]+s||s}return{counts:u({},n),sums:o,events:u({},i)}},tick:function(e){i[e]=r()},clear:function(e){delete i[e]},between:function(e,t){return i[t]&&i[e]?i[t]-i[e]:null}}};t.a=c},function(e,t,n){"use strict";function r(e){var t=document.createElement("link");return t.type="text/css",t.rel="stylesheet",t.href=e,t}function i(e){var t=document.createElement("script");return t.type="text/javascript",t.charset="utf-8",t.async=!0,t.timeout=l,t.src=e,t}var o=n(7),a=n(4),u=n(5),c=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},s={},l=15e3,f=2,d=3,p=function(e,t){function n(e){p=f,c.trigger(a.q,e).off()}function o(e){p=d,c.trigger(a._1,e).off()}var c=this,p=0;this.getStatus=function(){return p},this.load=function(){if(0===p){var a=s[e];return a&&a.then(o).catch(n),p=1,a=new u.a(function(a,u){var c=t?r:i,s=c(e),f=function(){s.onerror=s.onload=null,clearTimeout(p)},d=function(e){f(),n(e),u(e)},p=setTimeout(function(){d(new Error("Network timeout "+e))},l);s.onerror=function(){d(new Error("Failed to load "+e))},s.onload=function(e){f(),o(e),a(e)};var v=document.getElementsByTagName("head")[0]||document.documentElement;v.insertBefore(s,v.firstChild)}),s[e]=a,a}}};c(p.prototype,o.a),t.a=p},function(e,t,n){"use strict";function r(e,t,n){var r=e.name,i=document.createElement("div");i.id=n.id+"_"+r,i.className="jw-plugin jw-reset";var o=s({},t),a=e.getNewInstance(n,o,i);n.addPlugin(r,a)}function i(e){switch(y(e)){case m:return e;case g:return Object(p.getAbsolutePath)(e,window.location.href)}}function o(e){return E[e]=new f,E[e]}function a(e,t){var n=e.get("id"),r=e.get("plugins");window.jwplayerPluginJsonp=S;var i=o(n);return i.load(t,P,r).then(function(e){i===E[n]&&(e&&e.forEach(function(e){e instanceof Error&&Object(j.b)(e.message)}),delete window.jwplayerPluginJsonp)})}Object.defineProperty(t,"__esModule",{value:!0});var u=n(5),c="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},l=function(){this.load=function(e,t,n){return n&&"object"===(void 0===n?"undefined":c(n))?u.a.all(Object.keys(n).filter(function(e){return e}).map(function(i){var o=t.addPlugin(i,!0),a=n[i];return o.load().then(function(){r(o,a,e)}).catch(function(e){return e instanceof Error?e:new Error("Error in "+i+' "'+e+'"')})})):u.b}},f=l,d=n(22),p=n(13),v=n(1),h=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},m=0,g=1,y=function(e){if("string"==typeof e){e=e.split("?")[0];var t=e.indexOf("://");if(t>0)return m;var n=e.indexOf("/"),r=Object(v.a)(e);return!(t<0&&n<0)||r&&isNaN(r)?g:2}},b=function(e){this.url=e};h(b.prototype,{load:function(){if(2===y(this.url))return u.b;var e=new d.a(i(this.url));return this.loader=e,e.load()},registerPlugin:function(e,t,n){this.name=e,this.target=t,this.js=n},getNewInstance:function(e,t,n){var r=this.js,i=new r(e,t,n);return i.addToPlayer=function(){var t=e.getContainer().querySelector(".jw-overlays");t&&(n.left=t.style.left,n.top=t.style.top,t.appendChild(n),i.displayArea=t)},i.resizeHandler=function(){var e=i.displayArea;e&&i.resize(e.clientWidth,e.clientHeight)},i}});var w=b,j=n(6),O={},k=function(e){return e.replace(/^(.*\/)?([^-]*)-?.*\.(js)$/,"$2")},C=function(){this.addPlugin=function(e,t){var n=k(e),r=O[n];return r?t&&r.url!==e&&Object(j.b)('JW Plugin "'+n+'" already loaded from "'+r.url+'". Ignoring "'+e+'."'):(r=new w(e),O[n]=r),r},this.getPlugins=function(){return O}},x=C;n.d(t,"b",function(){return S}),t.a=a;var P=new x,E={},S=function(e,t,n){var r=P.addPlugin(e);r.js||r.registerPlugin(e,t,n)}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(38),i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},o=function(e){if(e&&e.file)return i({},{kind:"captions",default:!1},e)},a=o,u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},c=Array.isArray,s=function(e){e=e||{},c(e.tracks)||delete e.tracks;var t=u({},{sources:[],tracks:[],minDvrWindow:120},e);t.sources!==Object(t.sources)||c(t.sources)||(t.sources=[Object(r.a)(t.sources)]),c(t.sources)&&0!==t.sources.length||(e.levels?t.sources=e.levels:t.sources=[Object(r.a)(e)]);for(var n=0;n<t.sources.length;n++){var i=t.sources[n];if(i){var o=i.default;i.default=!!o&&"true"===o.toString(),t.sources[n].label||(t.sources[n].label=n.toString()),t.sources[n]=Object(r.a)(t.sources[n])}}return t.sources=t.sources.filter(function(e){return!!e}),c(t.tracks)||(t.tracks=[]),c(t.captions)&&(t.tracks=t.tracks.concat(t.captions),delete t.captions),t.tracks=t.tracks.map(a).filter(function(e){return!!e}),t};t.a=s},function(e,t,n){"use strict";function r(e,t){var n=" "+t+" ";return 1===e.nodeType&&(" "+e.className+" ").replace(/[\t\r\n\f]/g," ").indexOf(n)>=0}function i(e){var t=document.createElement("div");return t.innerHTML=e,t.firstChild}function o(e){return e+(e.toString().indexOf("%")>0?"":"px")}function a(e){return b.a.isString(e.className)?e.className.split(" "):[]}function u(e,t){t=Object(y.g)(t),e.className!==t&&(e.className=t)}function c(e){return e.classList?e.classList:a(e)}function s(e,t){var n=a(e),r=b.a.isArray(t)?t:t.split(" ");b.a.each(r,function(e){b.a.contains(n,e)||n.push(e)}),u(e,n.join(" "))}function l(e,t){var n=a(e),r=b.a.isArray(t)?t:t.split(" ");u(e,b.a.difference(n,r).join(" "))}function f(e,t,n){var r=e.className||"";t.test(r)?r=r.replace(t,n):n&&(r+=" "+n),u(e,r)}function d(e,t,n){var i=r(e,t);(n=b.a.isBoolean(n)?n:!i)!==i&&(n?s(e,t):l(e,t))}function p(e){for(;e.firstChild;)e.removeChild(e.firstChild)}function v(e){var t=document.createElement("link");t.rel="stylesheet",t.href=e,document.getElementsByTagName("head")[0].appendChild(t)}function h(e){e&&p(e)}function m(e){var t={left:0,right:0,width:0,height:0,top:0,bottom:0};if(!e||!document.body.contains(e))return t;var n=e.getBoundingClientRect(),r=window.pageYOffset,i=window.pageXOffset;return n.width||n.height||n.left||n.top?(t.left=n.left+i,t.right=n.right+i,t.top=n.top+r,t.bottom=n.bottom+r,t.width=n.right-n.left,t.height=n.bottom-n.top,t):t}function g(e,t){e.insertBefore(t,e.firstChild)}t.h=r,t.e=i,t.l=o,t.d=c,t.a=s,t.j=l,t.k=f,t.m=d,t.g=p,t.b=v,t.f=h,t.c=m,t.i=g;var y=n(1),b=n(0)},function(e,t,n){"use strict";function r(e,t,n,r){n=n||"all-players";var o="";if("object"===(void 0===t?"undefined":d(t))){var a=document.createElement("div");i(a,t);var u=a.style.cssText;r&&u&&(u=u.replace(/;/g," !important;")),o="{"+u+"}"}else"string"==typeof t&&(o=t);if(""===o||"{}"===o)return void f.a.clear(n,e);f.a.style([[e,e+o]],n)}function i(e,t){if(void 0!==e&&null!==e){void 0===e.length&&(e=[e]);var n,r={};for(n in t)Object.prototype.hasOwnProperty.call(t,n)&&(r[n]=a(n,t[n]));for(var i=0;i<e.length;i++){var u,c=e[i];if(void 0!==c&&null!==c)for(n in r)Object.prototype.hasOwnProperty.call(r,n)&&(u=o(n),c.style[u]!==r[n]&&(c.style[u]=r[n]))}}}function o(e){e=e.split("-");for(var t=1;t<e.length;t++)e[t]=e[t].charAt(0).toUpperCase()+e[t].slice(1);return e.join("")}function a(e,t){return""===t||void 0===t||null===t?"":"string"==typeof t&&isNaN(t)?/png|gif|jpe?g/i.test(t)&&t.indexOf("url")<0?"url("+t+")":t:0===t||"z-index"===e||"opacity"===e?""+t:/color/i.test(e)?"#"+Object(s.c)(t.toString(16).replace(/^0x/i,""),6):Math.ceil(t)+"px"}function u(e,t){i(e,{transform:t,webkitTransform:t,msTransform:t,mozTransform:t,oTransform:t})}function c(e,t){var n="rgb",r=void 0!==t&&100!==t;if(r&&(n+="a"),!v){var i=document.createElement("canvas");i.height=1,i.width=1,v=i.getContext("2d")}e?isNaN(parseInt(e,16))||(e="#"+e):e="#000000",v.clearRect(0,0,1,1),v.fillStyle=e,v.fillRect(0,0,1,1);var o=v.getImageData(0,0,1,1).data;return n+="("+o[0]+", "+o[1]+", "+o[2],r&&(n+=", "+t/100),n+")"}n.d(t,"a",function(){return p}),t.b=r,t.d=i,t.e=u,t.c=c;var s=n(1),l=n(41),f=n.n(l),d="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},p=f.a.clear,v=void 0},function(e,t,n){"use strict";var r=[];t.a=r},function(e,t,n){"use strict";function r(e){return e.some(function(e){return!!e.drm||e.sources.some(function(e){return!!e.drm})})}function i(e){return new l.a(function(t,n){var r=void 0;try{r=new window.MSMediaKeys(e)}catch(e){return void n(e)}t(r)})}function o(e){if(v)return v;if(a()&&Object(s.a)(e)("drm")){var t=i;return navigator.requestMediaKeySystemAccess&&(t=navigator.requestMediaKeySystemAccess.bind(navigator)),f.forEach(function(e){var n=t(e.keyName,[{initDataTypes:["cenc"],videoCapabilities:[{contentType:'video/mp4;codecs="avc1.4d401e"'}],audioCapabilities:[{contentType:'audio/mp4;codecs="mp4a.40.2"'}]}]).then(function(){p[e.configName]=!0}).catch(function(){p[e.configName]=!1});d.push(n)}),v=l.a.all(d)}return l.b}function a(){return!!navigator.requestMediaKeySystemAccess&&!!MediaKeySystemAccess.prototype.getConfiguration||!!window.MSMediaKeys}function u(e){return p[e]}function c(e){if(v)return Object.keys(e).some(function(e){return u(e)})}t.b=r,t.d=o,t.c=u,t.a=c;var s=n(15),l=n(5),f=[{configName:"clearkey",keyName:"org.w3.clearkey"},{configName:"widevine",keyName:"com.widevine.alpha"},{configName:"playready",keyName:"com.microsoft.playready"}],d=[],p={},v=void 0},function(e,t,n){"use strict";function r(e){return null!==g.match(e)}function i(e){return function(){return r(e)}}function o(){var e=m();return!!(e&&e>=18)}function a(){return r(/\sEdge\/\d+/i)}function u(){return r(/msie/i)}function c(){return r(/\s(?:Chrome|CriOS)\//i)&&!a()}function s(){return a()||b()||u()}function l(){return r(/safari/i)&&!r(/(?:Chrome|CriOS|chromium|android)/i)}function f(){return r(/iP(hone|ad|od)/i)}function d(){return!(r(/chrome\/[123456789]/i)&&!r(/chrome\/18/i)&&!y())&&p()}function p(){return r(/Android/i)}function v(){return f()||p()}function h(){try{return window.self!==window.top}catch(e){return!0}}function m(){if(p())return 0;var e,t=navigator.plugins;if(t&&(e=t["Shockwave Flash"])&&e.description)return parseFloat(e.description.replace(/\D+(\d+\.?\d*).*/,"$1"));if(void 0!==window.ActiveXObject){try{if(e=new window.ActiveXObject("ShockwaveFlash.ShockwaveFlash"))return parseFloat(e.GetVariable("$version").split(" ")[1].replace(/\s*,\s*/,"."))}catch(e){return 0}return e}return 0}t.h=o,n.d(t,"f",function(){return y}),n.d(t,"l",function(){return w}),n.d(t,"k",function(){return j}),n.d(t,"p",function(){return O}),n.d(t,"g",function(){return k}),t.e=a,t.n=u,t.d=c,t.i=s,t.q=l,t.j=f,t.c=d,t.b=p,t.o=v,t.m=h,t.a=m;var g=navigator.userAgent,y=i(/gecko\//i),b=i(/trident\/.+rv:\s*11/i),w=i(/iP(hone|od)/i),j=i(/iPad/i),O=i(/Macintosh/i),k=i(/FBAV/i)},function(e,t,n){"use strict";function r(e,t){return s[e]?e:s[t]?t:"metadata"}function i(e,t,n){var i=[],u=t.getProviders(),c=t.get("preload"),s=p({},n);return delete s.playlist,e.forEach(function(e){e=p({},e),e.preload=r(e.preload,c),e.allSources=o(e,t),e.sources=a(e.allSources,u),e.sources.length&&(e.file=e.sources[0].file,n&&(e.feedData=s),i.push(e))}),i}function o(e,t){var n=e.sources,i=t.get("androidhls"),o=t.get("safarihlsjs"),a=e.drm||t.get("drm"),u=c(e.withCredentials,t.get("withCredentials")),s=!1!==t.get("hlsjsdefault");return n.map(function(t){if(t!==Object(t))return null;void 0!==i&&null!==i&&(t.androidhls=i),void 0!==o&&null!==o&&(t.safarihlsjs=o),(t.drm||a)&&(t.drm=t.drm||a),t.preload=r(t.preload,e.preload);var n=c(t.withCredentials,u);return void 0!==n&&(t.withCredentials=n),s&&(t.hlsjsdefault=s),Object(f.a)(t)}).filter(function(e){return!!e})}function a(e,t){t&&t.choose||(t=new d.a);var n=u(e,t);if(!n)return[];var r=n.provider,i=n.type;return e.filter(function(e){return e.type===i&&t.providerSupports(r,e)})}function u(e,t){for(var n=0;n<e.length;n++){var r=e[n],i=t.choose(r);if(i)return{type:r.type,provider:i.providerToCheck}}return null}function c(e,t){return void 0===e?t:e}Object.defineProperty(t,"__esModule",{value:!0});var s={none:!0,metadata:!0,auto:!0},l=n(24),f=n(38),d=n(31);t.b=i;var p=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},v=function(e){return(Array.isArray(e)?e:[e]).map(l.a)};t.a=v},function(e,t,n){"use strict";function r(e){this.config=e||{}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(17),o=n(18),a=n(35),u=n(8),c=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},s={html5:function(){return n.e(7).then(function(e){var t=n(11).default;return Object(o.a)(t),t}.bind(null,n)).catch(u.b)}};c(r.prototype,{load:function(e){return Promise.all(e.filter(function(e){return!!s[e.name]}).map(function(e){return(0,s[e.name])()}))},providerSupports:function(e,t){return e.supports(t)},required:function(e){var t=this;return e=e.slice(),i.a.filter(function(n){for(var r=!1,i=e.length;i--;){var o=e[i],a=t.providerSupports(n,o.sources[0]);a&&e.splice(i,1),r=r||a}return r})},choose:function(e){e=e===Object(e)?e:{};for(var t=i.a.length,n=0;n<t;n++){var r=i.a[n];if(this.providerSupports(r,e)){return{priority:t-n-1,name:r.name,type:e.type,providerToCheck:r,provider:a.a[r.name]}}}return null}});var l=r,f=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},d=void 0;f(s,{shaka:function(){return n.e(5).then(function(e){var t=n(121).default;return Object(o.a)(t),t}.bind(null,n)).catch(u.b)},hlsjs:function(){return n.e(6).then(function(e){var t=n(122).default;return t.setEdition&&t.setEdition(d),Object(o.a)(t),t}.bind(null,n)).catch(u.b)},flash:function(){return n.e(9).then(function(e){var t=n(123).default;return Object(o.a)(t),t}.bind(null,n)).catch(u.b)}}),l.prototype.providerSupports=function(e,t){return d=this.config.edition,e.supports(t,d)};t.a=l},function(e,t,n){"use strict";function r(e){this.message=e}function i(e){var t=String(e).replace(/=+$/,"");if(t.length%4==1)throw new r("'atob' failed: The string to be decoded is not correctly encoded.");for(var n,i,a="",u=0,c=0;i=t.charAt(c++);~i&&(n=u%4?64*n+i:i,u++%4)?a+=String.fromCharCode(255&n>>(-2*u&6)):0)i=o.indexOf(i);return a}n.d(t,"a",function(){return a});var o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";r.prototype=new Error,r.prototype.name="InvalidCharacterError";var a=window.atob||i},function(e,t,n){"use strict";n.d(t,"a",function(){return r});var r=Date.now||function(){return(new Date).getTime()}},function(e,t,n){"use strict";var r=document.createElement("video");t.a=r},function(e,t,n){"use strict";var r={};t.a=r},function(e,t,n){"use strict";var r=n(37),i=n(15),o=n(32),a="invalid",u=function(e){var t=void 0,n=void 0,u=void 0;this.edition=function(){return u&&u.getTime()<(new Date).getTime()?a:t},this.token=function(){return n},this.expiration=function(){return u},function(e,c){try{var s=Object(r.a)(e,Object(o.a)(c)),l=s.split("/");"pro"===(t=l[0])&&(t="premium");var f=Object(i.a)(t);if(l.length>2&&f("setup")){n=l[1];var d=parseInt(l[2]);d>0&&(u=new Date,u.setTime(d))}else t=a}catch(e){t=a}}(e||"","NDh2aU1Cb0NHRG5hcDFRZQ==")};t.a=u},function(e,t,n){"use strict";function r(e){return Object(s.a)(e)}function i(e){return unescape(encodeURIComponent(e))}function o(e){try{return decodeURIComponent(escape(e))}catch(t){return e}}function a(e){for(var t=new Array(Math.ceil(e.length/4)),n=0;n<t.length;n++)t[n]=e.charCodeAt(4*n)+(e.charCodeAt(4*n+1)<<8)+(e.charCodeAt(4*n+2)<<16)+(e.charCodeAt(4*n+3)<<24);return t}function u(e){for(var t=new Array(e.length),n=0;n<e.length;n++)t[n]=String.fromCharCode(255&e[n],e[n]>>>8&255,e[n]>>>16&255,e[n]>>>24&255);return t.join("")}function c(e,t){if(e=String(e),t=String(t),0===e.length)return"";for(var n=a(r(e)),c=a(i(t).slice(0,16)),s=n.length,l=n[s-1],f=n[0],d=void 0,p=void 0,v=2654435769*Math.floor(6+52/s);v;){p=v>>>2&3;for(var h=s-1;h>=0;h--)l=n[h>0?h-1:s-1],d=(l>>>5^f<<2)+(f>>>3^l<<4)^(v^f)+(c[3&h^p]^l),f=n[h]-=d;v-=2654435769}return o(u(n).replace(/\0+$/,""))}t.a=c;var s=n(32)},function(e,t,n){"use strict";var r=n(12),i=n(1),o=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},a=function(e){if(e&&e.file){var t=o({},{default:!1},e);t.file=Object(i.g)(""+t.file);var n=/^[^\/]+\/(?:x-)?([^\/]+)$/;if(n.test(t.type)&&(t.mimeType=t.type,t.type=t.type.replace(n,"$1")),Object(r.isYouTube)(t.file)?t.type="youtube":Object(r.isRtmp)(t.file)?t.type="rtmp":t.type||(t.type=Object(i.a)(t.file)),t.type){switch(t.type){case"m3u8":case"vnd.apple.mpegurl":t.type="hls";break;case"dash+xml":t.type="dash";break;case"m4a":t.type="aac";break;case"smil":t.type="rtmp"}return Object.keys(t).forEach(function(e){""===t[e]&&delete t[e]}),t}}};t.a=a},function(e,t,n){"use strict";function r(e){for(var t=[],n=0;n<Object(a.c)(e);n++){var r=e.childNodes[n];"jwplayer"===r.prefix&&"mediatypes"===Object(a.b)(r).toLowerCase()&&t.push(Object(a.d)(r))}return t}function i(e){var t=[];t.feedData={};for(var n=0;n<Object(a.c)(e);n++){var r=Object(a.a)(e,n);if("channel"===Object(a.b)(r).toLowerCase())for(var i=0;i<Object(a.c)(r);i++){var u=Object(a.a)(r,i),c=Object(a.b)(u).toLowerCase();"item"===c?t.push(o(u)):c&&(t.feedData[c]=Object(a.d)(u))}}return t}function o(e){for(var t={},n=0;n<e.childNodes.length;n++){var r=e.childNodes[n],i=Object(a.b)(r);if(i)switch(i.toLowerCase()){case"enclosure":t.file=Object(u.h)(r,"url");break;case"title":t.title=Object(a.d)(r);break;case"guid":t.mediaid=Object(a.d)(r);break;case"pubdate":t.date=Object(a.d)(r);break;case"description":t.description=Object(a.d)(r);break;case"link":t.link=Object(a.d)(r);break;case"category":t.tags?t.tags+=Object(a.d)(r):t.tags=Object(a.d)(r)}}return new p.a(d(e,l(e,t)))}Object.defineProperty(t,"__esModule",{value:!0});var a=n(10),u=n(1),c=n(6),s=function e(t,n){for(var i=[],o=0;o<Object(a.c)(t);o++){var s=t.childNodes[o];if("media"===s.prefix){if(!Object(a.b)(s))continue;switch(Object(a.b)(s).toLowerCase()){case"content":if(Object(u.h)(s,"duration")&&(n.duration=c.a.seconds(Object(u.h)(s,"duration"))),Object(u.h)(s,"url")){n.sources||(n.sources=[]);var l={file:Object(u.h)(s,"url"),type:Object(u.h)(s,"type"),width:Object(u.h)(s,"width"),label:Object(u.h)(s,"label")},f=r(s);f.length&&(l.mediaTypes=f),n.sources.push(l)}Object(a.c)(s)>0&&(n=e(s,n));break;case"title":n.title=Object(a.d)(s);break;case"description":n.description=Object(a.d)(s);break;case"guid":n.mediaid=Object(a.d)(s);break;case"thumbnail":n.image||(n.image=Object(u.h)(s,"url"));break;case"group":e(s,n);break;case"subtitle":var d={};d.file=Object(u.h)(s,"url"),d.kind="captions",Object(u.h)(s,"lang").length>0&&(d.label=function(e){var t={zh:"Chinese",nl:"Dutch",en:"English",fr:"French",de:"German",it:"Italian",ja:"Japanese",pt:"Portuguese",ru:"Russian",es:"Spanish"};return t[e]?t[e]:e}(Object(u.h)(s,"lang"))),i.push(d)}}}n.hasOwnProperty("tracks")||(n.tracks=[]);for(var p=0;p<i.length;p++)n.tracks.push(i[p]);return n},l=s,f=function(e,t){for(var n="default",r=[],i=[],o=0;o<e.childNodes.length;o++){var s=e.childNodes[o];if("jwplayer"===s.prefix){var l=Object(a.b)(s);"source"===l?(delete t.sources,r.push({file:Object(u.h)(s,"file"),default:Object(u.h)(s,n),label:Object(u.h)(s,"label"),type:Object(u.h)(s,"type")})):"track"===l?(delete t.tracks,i.push({file:Object(u.h)(s,"file"),default:Object(u.h)(s,n),kind:Object(u.h)(s,"kind"),label:Object(u.h)(s,"label")})):(t[l]=c.a.serialize(Object(a.d)(s)),"file"===l&&t.sources&&delete t.sources)}t.file||(t.file=t.link)}if(r.length){t.sources=[];for(var f=0;f<r.length;f++)r[f].file.length>0&&(r[f][n]="true"===r[f][n],r[f].label.length||delete r[f].label,t.sources.push(r[f]))}if(i.length){t.tracks=[];for(var d=0;d<i.length;d++)i[d].file.length>0&&(i[d][n]="true"===i[d][n],i[d].kind=i[d].kind.length?i[d].kind:"captions",i[d].label.length||delete i[d].label,t.tracks.push(i[d]))}return t},d=f,p=n(24);t.a=i},function(e,t,n){"use strict";function r(e,t){return/touch/.test(e.type)?(e.originalEvent||e).changedTouches[0]["page"+t]:e["page"+t]}function i(e){var t=e||window.event;return e instanceof MouseEvent&&("which"in t?3===t.which:"button"in t&&2===t.button)}function o(e){var t=e||window.event;return t instanceof KeyboardEvent&&13===t.keyCode&&(e.stopPropagation(),!0)}function a(e,t,n){var r=void 0;return r=t instanceof MouseEvent||!t.touches&&!t.changedTouches?t:t.touches&&t.touches.length?t.touches[0]:t.changedTouches[0],{type:e,sourceEvent:t,target:t.target,currentTarget:n,pageX:r.pageX,pageY:r.pageY}}function u(e){(e instanceof MouseEvent||e instanceof window.TouchEvent)&&(e.preventManipulation&&e.preventManipulation(),e.preventDefault&&e.preventDefault())}n.d(t,"b",function(){return y});var c=n(14),s=n(4),l=n(7),f=n(33),d=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},p="PointerEvent"in window&&!c.OS.android,v="ontouchstart"in window,h=!(p||v&&c.OS.mobile),m=c.Browser.firefox&&c.OS.mac,g=function(e,t){function n(e){"touch"!==e.pointerType&&w(s.P,e)}function c(e){"touch"!==e.pointerType&&w(s.N,e)}function l(t){(h||p&&"touch"!==t.pointerType&&!e.contains(document.elementFromPoint(t.x,t.y)))&&w(s.O,t)}function d(e){o(e)&&w(s.p,e)}function v(e,t,n){e.removeEventListener(t,n),e.addEventListener(t,n)}function g(n){E=n.target,k=r(n,"X"),C=r(n,"Y"),i(n)||("pointerdown"===n.type&&n.isPrimary?(t.preventScrolling&&(S=n.pointerId,e.setPointerCapture(S)),v(e,"pointermove",y),v(e,"pointercancel",b),"mouse"===n.pointerType&&"OBJECT"===E.nodeName?v(document,"mouseup",b):v(e,"pointerup",b)):"mousedown"===n.type?(v(document,"mousemove",y),m&&"object"===n.target.nodeName.toLowerCase()?v(e,"click",b):v(document,"mouseup",b)):"touchstart"===n.type&&(v(E,"touchmove",y),v(E,"touchcancel",b),v(E,"touchend",b)),t.preventScrolling&&u(n))}function y(e){if(O)w(s.m,e);else{var n=r(e,"X"),i=r(e,"Y"),o=n-k,a=i-C;o*o+a*a>36&&(w(s.o,e),O=!0,w(s.m,e))}t.preventScrolling&&u(e)}function b(n){var r="pointerup"===n.type||"pointercancel"===n.type;r&&t.preventScrolling&&e.releasePointerCapture(S),e.removeEventListener("pointermove",y),e.removeEventListener("pointercancel",b),e.removeEventListener("pointerup",b),document.removeEventListener("mousemove",y),document.removeEventListener("mouseup",b),E&&(E.removeEventListener("touchmove",y),E.removeEventListener("touchcancel",b),E.removeEventListener("touchend",b)),O?w(s.n,n):t.directSelect&&n.target!==e||-1!==n.type.indexOf("cancel")||("mouseup"===n.type||"click"===n.type||r&&"mouse"===n.pointerType?w(s.h,n):(w(s._8,n),"touchend"===n.type&&u(n))),E=null,O=!1}function w(e,n){var r=void 0;if(t.enableDoubleTap&&(e===s.h||e===s._8))if(Object(f.a)()-x<P){var i=e===s.h?s.k:s.l;r=a(i,n,j),T.trigger(i,r),x=0}else x=Object(f.a)();r=a(e,n,j),T.trigger(e,r)}var j=e,O=!1,k=0,C=0,x=0,P=300,E=void 0,S=void 0;t=t||{},p?(e.addEventListener("pointerdown",g),t.useHover&&(e.addEventListener("pointerover",n),e.addEventListener("pointerout",l)),t.useMove&&e.addEventListener("pointermove",c)):(h&&(e.addEventListener("mousedown",g),t.useHover&&(e.addEventListener("mouseover",n),e.addEventListener("mouseout",l)),t.useMove&&e.addEventListener("mousemove",c)),e.addEventListener("touchstart",g)),e.addEventListener("keydown",d),t.useFocus&&(e.addEventListener("focus",n),e.addEventListener("blur",l));var T=this;return this.triggerEvent=w,this.destroy=function(){this.off(),e.removeEventListener("touchstart",g),e.removeEventListener("mousedown",g),e.removeEventListener("keydown",d),E&&(E.removeEventListener("touchmove",y),E.removeEventListener("touchcancel",b),E.removeEventListener("touchend",b),E=null),p&&(t.preventScrolling&&e.releasePointerCapture(S),e.removeEventListener("pointerover",n),e.removeEventListener("pointerdown",g),e.removeEventListener("pointermove",y),e.removeEventListener("pointermove",c),e.removeEventListener("pointercancel",b),e.removeEventListener("pointerout",l),e.removeEventListener("pointerup",b)),e.removeEventListener("click",b),e.removeEventListener("mouseover",n),e.removeEventListener("mousemove",c),e.removeEventListener("mouseout",l),document.removeEventListener("mousemove",y),document.removeEventListener("mouseup",b),t.useFocus&&(e.removeEventListener("focus",n),e.removeEventListener("blur",l))},this};g.getPointerType=function(e){return p&&e instanceof window.PointerEvent?"touch"===e.pointerType?"touch":"mouse":v&&e instanceof window.TouchEvent?"touch":"mouse"},d(g.prototype,l.a);var y=g.getPointerType;t.a=g},function(e,t,n){var r;void 0!==(r=function(e,t,n){function r(e,t){o(t,a(e))}function i(e,t){var n=f[e];if(n)if(t){var r=n[t];if(r)for(var i=0;i<r.parts.length;i+=1)r.parts[i]()}else{for(var o=Object.keys(n),a=0;a<o.length;a+=1)for(var u=n[o[a]],c=0;c<u.parts.length;c+=1)u.parts[c]();delete f[e]}}function o(e,t){for(var n=0;n<t.length;n++){var r=t[n],i=(f[e]||{})[r.id];if(i){for(var o=0;o<i.parts.length;o++)i.parts[o](r.parts[o]);for(;o<r.parts.length;o++)i.parts.push(s(e,r.parts[o]))}else{for(var a=[],o=0;o<r.parts.length;o++)a.push(s(e,r.parts[o]));f[e]=f[e]||{},f[e][r.id]={id:r.id,parts:a}}}}function a(e){for(var t=[],n={},r=0;r<e.length;r++){var i=e[r],o=i[0],a=i[1],u=i[2],c={css:a,media:u};n[o]?n[o].parts.push(c):t.push(n[o]={id:o,parts:[c]})}return t}function u(e){p().appendChild(e)}function c(e){var t=document.createElement("style");return t.type="text/css",t.setAttribute("data-jwplayer-id",e),u(t),t}function s(e,t){var n,r,i,o=d[e];o||(o=d[e]={element:c(e),counter:0});var a=o.counter++;return n=o.element,r=function(e){l(n,a,e)},i=function(){l(n,a,"")},r(t.css),function(e){if(e){if(e.css===t.css&&e.media===t.media)return;t=e,r(t.css)}else i()}}function l(e,t,n){if(e.styleSheet)e.styleSheet.cssText=v(t,n);else{var r=document.createTextNode(n),i=e.childNodes,o=i[t];o?e.replaceChild(r,o):e.appendChild(r)}}var f={},d={},p=function(e){var t;return function(){return void 0===t&&(t=e.apply(this,arguments)),t}}(function(){return document.head||document.getElementsByTagName("head")[0]});n.exports={style:r,clear:i};var v=function(){var e=[];return function(t,n){return e[t]=n,e.filter(Boolean).join("\n")}}()}.call(t,n,t,e))&&(e.exports=r)},function(e,t,n){"use strict";function r(e){var t=e.get("playlist"),n=e.getProviders(),r=n.required(t);return n.load(r)}t.b=r;var i=n(30),o=function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(e.set("feedData",n),n.error instanceof Error)throw n.error;var r=Object(i.b)(t,e,n);if(e.set("playlist",r),!Array.isArray(r)||0===r.length)throw new Error("No playable sources found")};t.a=o},function(e,t,n){"use strict";function r(e,t){var n=t.indexOf(":")+1,r=n>0?t.substr(0,n):"Error loading player:",u=t.substr(n),c=i(e.get("id"),r,u),s=e.get("width"),l=e.get("height"),f=Object(o.e)(c);return Object(a.d)(f,{width:s.toString().indexOf("%")>0?s:s+"px",height:l.toString().indexOf("%")>0?l:l+"px"}),f}Object.defineProperty(t,"__esModule",{value:!0});var i=function(e){return'<div id="'+e+'" class="jw-error jw-reset"><div class="jw-error-msg jw-reset"><style>[id="'+e+'"].jw-error{position:relative;background:#000;overflow:hidden;position:relative}[id="'+e+'"] .jw-error-msg{top:50%;left:50%;position:absolute;align-items:center;display:flex;transform:translate(-50%,-50%)}[id="'+e+'"] .jw-title{color:#FFF;position:static}[id="'+e+'"] .jw-title-primary,[id="'+e+'"] .jw-title-secondary{font:600 14px/1.35 Arial,Helvetica,sans-serif}[id="'+e+'"] .jw-title-secondary{font-weight:400}</style><div class="jw-icon jw-reset"></div><div class="jw-title jw-reset"><div class="jw-title-primary jw-reset">'+(arguments.length>1&&void 0!==arguments[1]?arguments[1]:"")+'</div><div class="jw-title-secondary jw-reset">'+(arguments.length>2&&void 0!==arguments[2]?arguments[2]:"")+"</div></div></div></div>"},o=n(25),a=n(26);t.a=r},function(e,t,n){"use strict";var r=n(4),i=function(){},o=function(){return!1},a={supports:o,play:i,preload:i,load:i,stop:i,volume:i,mute:i,seek:i,resize:i,remove:i,destroy:i,setVisibility:i,setFullscreen:o,getFullscreen:i,getContainer:i,setContainer:o,getName:i,getQualityLevels:i,getCurrentQuality:i,setCurrentQuality:i,getAudioTracks:i,getCurrentAudioTrack:i,setCurrentAudioTrack:i,setPlaybackRate:i,getPlaybackRate:function(){return 1},checkComplete:i,setControls:i,attachMedia:i,detachMedia:i,init:i,setState:function(e){this.state=e,this.trigger(r.R,{newstate:e})},sendMediaType:function(e){var t=e[0].type,n="oga"===t||"aac"===t||"mp3"===t||"mpeg"===t||"vorbis"===t;this.trigger(r.L,{mediaType:n?"audio":"video"})}};t.a=a},function(e,t,n){"use strict";function r(e){j.a.each(e,function(t,n){e[n]=Object(k.serialize)(t)})}function i(e){return e.slice&&"px"===e.slice(-2)&&(e=e.slice(0,-2)),e}function o(e,t){if(-1===t.toString().indexOf("%"))return 0;if("string"!=typeof e||!e)return 0;if(/^\d*\.?\d+%$/.test(e))return e;var n=e.indexOf(":");if(-1===n)return 0;var r=parseFloat(e.substr(0,n)),i=parseFloat(e.substr(n+1));return r<=0||i<=0?0:i/r*100+"%"}function a(e){var t=e.flashplayer;return t||(t=(Object(O.getScriptPath)("jwplayer.js")||e.base)+"jwplayer.flash.swf"),"http:"===window.location.protocol&&(t=t.replace(/^https/,"http")),t}function u(e){var t="file:"===window.location.protocol?"https:":"",n={jwpsrv:"//ssl.p.jwpcdn.com/player/v/8.0.10/jwpsrv.js",dai:"//ssl.p.jwpcdn.com/player/plugins/dai/v/0.1.2/dai.js",vast:"//ssl.p.jwpcdn.com/player/plugins/vast/v/8.0.3/vast.js",googima:"//ssl.p.jwpcdn.com/player/plugins/googima/v/8.0.5/googima.js",freewheel:"//ssl.p.jwpcdn.com/player/plugins/freewheel/v/2.0.4/freewheel.js",related:"//ssl.p.jwpcdn.com/player/plugins/related/v/6.1.1/related.js",gapro:"//ssl.p.jwpcdn.com/player/plugins/gapro/v/2.1.0/gapro.js",vr:"//ssl.p.jwpcdn.com/player/plugins/vr/v/2.0.1/vr.js"},r=n[e];return r?t+r:""}function c(e,t,n){if(t){e[t.client||u(n)]=t,delete t.client}}function s(e){var t=_({},e.plugins),n=e.edition,r=Object(T.a)(n);if(r("ads")){var i=_({},e.advertising),o=i.client;if(o){var a=u(o)||o;t[a]=i,delete i.client}}if(r("jwpsrv")){var s=e.analytics;s!==Object(s)&&(s={}),c(t,s,"jwpsrv")}c(t,e.ga,"gapro");var l=e.related,f=l===Object(l)&&r("discovery");if(!1!==e.controls||f){var d=!1!==e.visualplaylist||f;f||(l={disableRelated:!0}),l.showButton=d,c(t,l,"related")}if(!e.mobileSdk){var p=e.playlist;Array.isArray(p)&&Array.prototype.some.call(p,function(n){if(n.stereomode&&n.stereomode.length>0)return c(t,e.vr||{},"vr"),!0})}return t}function l(e){var t=e.get("playlist");return"string"==typeof t?new F.a(function(n){var r=new I.a;r.on(A.U,function(t){var r=Object(R.a)(t.playlist);delete t.playlist,e.attributes.playlist=r,e.attributes.feedData=t,n()}),r.on(A.q,function(t){e.attributes.playlist=[],e.set("feedData",{error:new Error("Error loading playlist: "+t.message)}),n()}),r.load(t)}):(e.attributes.playlist=Object(R.a)(t),F.b)}function f(e){return l(e).then(function(){if(!v(e)){Object(L.a)(e,e.get("playlist"),e.get("feedData"));var t=e.get("playlist"),n=e.getProviders(),r=n.required([t[0]]);if(!q.a.html5||!r||"html5"!==r[0].name)return n.load(r)}})}function d(e){for(var t=document.styleSheets,n=0,r=t.length;n<r;n++)if(t[n].href===e)return!0;return!1}function p(e){var t=e.get("skin")?e.get("skin").url:void 0;if("string"==typeof t&&!d(t)){return new B.a(t,!0).load().catch(function(e){return e})}return F.b}function v(e){return e.attributes._destroyed}function h(e){return l(e).then(function(){return e.get("drm")||Object(Q.b)(e.get("playlist"))?Object(Q.d)(e.get("edition")):F.b})}function m(e){return h(e).then(function(){return X(e)})}function g(e,t){this.namespace=e,this.items=t}function y(e,t){F.b.then(function(){var n=t.message,r=t.code,i=Object(te.a)(e,n);te.a.cloneIcon&&i.querySelector(".jw-icon").appendChild(te.a.cloneIcon("error")),b(e,i);var o={message:n,code:r,error:t},a=e._model||e.modelShim;a.set("errorEvent",o),a.set("state",A._2),e.trigger(A.Z,o)})}function b(e,t){if(!document.body.contains(e.currentContainer)){var n=document.getElementById(e.get("id"));n&&(e.currentContainer=n)}e.currentContainer.parentElement&&e.currentContainer.parentElement.replaceChild(t,e.currentContainer),e.currentContainer=t}Object.defineProperty(t,"__esModule",{value:!0});var w=n(46),j=n(0),O=n(16),k=n(13),C=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},x={autostart:!1,controls:!0,displaytitle:!0,displaydescription:!0,defaultPlaybackRate:1,playbackRateControls:!1,playbackRates:[.5,1,1.25,1.5,2],repeat:!1,castAvailable:!1,stretching:"uniform",mute:!1,volume:90,width:640,height:360,audioMode:!1,localization:{player:"Video Player",play:"Play",playback:"Start Playback",pause:"Pause",volume:"Volume",prev:"Previous",next:"Next",cast:"Chromecast",airplay:"AirPlay",fullscreen:"Fullscreen",playlist:"Playlist",hd:"Quality",cc:"Closed Captions",audioTracks:"Audio Tracks",playbackRates:"Playback Rates",replay:"Replay",buffer:"Loading",more:"More",liveBroadcast:"Live broadcast",loadingAd:"Loading ad",rewind:"Rewind 10 Seconds",nextUp:"Next Up",nextUpClose:"Next Up Close",related:"Discover",close:"Close",settings:"Settings",unmute:"Unmute"},renderCaptionsNatively:!1,nextUpDisplay:!0},P=function(e,t){var a=C({},(window.jwplayer||{}).defaults,t,e);r(a),a.localization=C({},x.localization,a.localization);var u=C({},x,a);"."===u.base&&(u.base=Object(O.getScriptPath)("jwplayer.js")),u.base=(u.base||Object(O.loadFrom)()).replace(/\/?$/,"/"),n.p=u.base,u.width=i(u.width),u.height=i(u.height),u.aspectratio=o(u.aspectratio,u.width);var c=u.playbackRateControls;if(c){var s=u.playbackRates;Array.isArray(c)&&(s=c),s=s.filter(function(e){return j.a.isNumber(e)&&e>=.25&&e<=4}).map(function(e){return Math.round(4*e)/4}),s.indexOf(1)<0&&s.push(1),s.sort(),u.playbackRateControls=!0,u.playbackRates=s}(!u.playbackRateControls||u.playbackRates.indexOf(u.defaultPlaybackRate)<0)&&(u.defaultPlaybackRate=1),u.playbackRate=u.defaultPlaybackRate,u.aspectratio||delete u.aspectratio;var l=u.playlist;if(l)Array.isArray(l.playlist)&&(u.feedData=l,u.playlist=l.playlist);else{var f=j.a.pick(u,["title","description","type","mediaid","image","file","sources","tracks","preload"]);u.playlist=[f]}return u.qualityLabels=u.qualityLabels||u.hlslabels,u},E=P,S=n(36),T=n(15),_=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},M=function(e,t){var r=E(e,t),i=r.key||window.jwplayer&&window.jwplayer.key,o=new S.a(i),u=o.edition();if(r.key=i,r.edition=u,r.error=null,"unlimited"===u){var c=Object(O.getScriptPath)("jwplayer.js");if(!c)throw new Error("Error setting up player: Could not locate jwplayer.js script tag");n.p=c}if("invalid"===u){var l=void 0===i?"Missing":"Invalid";r.error=new Error("Error setting up player: "+l+" license key")}return r.flashplayer=a(r),r.plugins=s(r),r},N=M,L=n(42),A=n(4),F=n(5),I=n(48),R=n(30),B=n(22),q=n(8),D=function(e){return v(e)?F.a.reject():F.a.all([f(e),p(e)])},X=D,Q=n(28),z=function(e){var t=void 0;this.start=function(){var n=m(e);return new Promise(function(e,r){return t=setTimeout(function(){r(new Error("Setup Timeout Error: Setup took longer than 30 seconds to complete."))},3e4),n.then(e).catch(r)})},this.destroy=function(){clearTimeout(t),e=null}},V=z,H=n(31),W=n(23),U=n(21),J=n(19),$=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},K={removeItem:function(){}};try{K=window.localStorage}catch(e){}$(g.prototype,{getAllItems:function(){var e=this;return this.items.reduce(function(t,n){var r=K[e.namespace+"."+n];return r&&(t[n]=Object(k.serialize)(r)),t},{})},track:function(e){var t=this;this.items.forEach(function(n){e.on("change:"+n,function(e,r){try{K[t.namespace+"."+n]=r}catch(e){J.a.debug&&console.error(e)}})})},clear:function(){var e=this;this.items.forEach(function(t){K.removeItem(e.namespace+"."+t)})}});var Y=g,G=n(49),Z=n(50),ee=n(7),te=n(43),ne=n(51);t.b=b;var re=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},ie=function(){};re(ie.prototype,G.a);var oe=function(e){this._events={},this.modelShim=new ie,this.modelShim._qoeItem=new U.a,this.setup=new V(this.modelShim),this.currentContainer=this.originalContainer=e,this.apiQueue=new w.a(this,["load","play","pause","seek","stop","playlistItem","playlistNext","playlistPrev","next","setConfig","setCurrentAudioTrack","setCurrentCaptions","setCurrentQuality","setFullscreen","addButton","removeButton","castToggle","setMute","setVolume","setPlaybackRate","resize","setCaptions","setControls","setCues"],function(){return!0})};re(oe.prototype,{on:ee.a.on,once:ee.a.once,off:ee.a.off,trigger:ee.a.trigger,init:function(e,t){var n=this,r=this.modelShim,i=new Y("jwplayer",["volume","mute","captionLabel","qualityLabel"]),o=i&&i.getAllItems();r.attributes=r.attributes||{};var a=N(e,o);return re(r.attributes,a,Z.a),r.getProviders=function(){return new H.a(a)},r.setProvider=function(){},(r.attributes.mediaElement=Object(ne.a)(this.originalContainer)).load(),F.a.all([Object(q.c)(r),this.setup.start(),Object(W.a)(r,t)]).then(function(e){var r=e[0];if(n.setup){var o=n.modelShim.clone();if(o.error instanceof Error)throw o.error;var a=n.apiQueue.queue.slice(0);n.apiQueue.destroy(),re(n,r.prototype),n.setup(o,t,n.originalContainer,n._events,a);var u=n._model;return i.track(u),u.setItemIndex(u.get("item"))}}).then(function(){n.setup&&n.playerReady()}).catch(function(e){n.setup&&y(n,e)})},playerDestroy:function(){this.apiQueue&&this.apiQueue.destroy(),this.setup&&this.setup.destroy(),this.off(),this._events=this._model=this.originalContainer=this.apiQueue=this.setup=null},getContainer:function(){return this.currentContainer},get:function(e){return this.modelShim.get(e)},getItemQoe:function(){return this.modelShim._qoeItem},getConfig:function(){return re({},this.modelShim.attributes)},getCurrentCaptions:function(){return this.get("captionsIndex")},getWidth:function(){return this.get("containerWidth")},getHeight:function(){return this.get("containerHeight")},getMute:function(){return this.get("mute")},getProvider:function(){return this.get("provider")},getState:function(){return this.get("state")},getAudioTracks:function(){return null},getCaptionsList:function(){return null},getQualityLevels:function(){return null},getVisualQuality:function(){return null},getCurrentQuality:function(){return-1},getCurrentAudioTrack:function(){return-1},getSafeRegion:function(){return{x:0,y:0,width:0,height:0}},isBeforeComplete:function(){return!1},isBeforePlay:function(){return!1},createInstream:function(){return null},skipAd:function(){},attachMedia:function(){},detachMedia:function(){return null}});t.a=oe},function(e,t,n){"use strict";function r(e,t,n){function r(){for(;i.length>0;){var t=i.shift(),n=t.command,r=t.args;(o[n]||e[n]).apply(e,r)}}var i=[],o={};t.forEach(function(t){var a=e[t];o[t]=a,e[t]=function(){var e=Array.prototype.slice.call(arguments,0);n()?i.push({command:t,args:e}):(r(),a&&a.apply(this,e))}}),Object.defineProperty(this,"queue",{enumerable:!0,get:function(){return i}}),this.flush=r,this.empty=function(){i.length=0},this.destroy=function(){i.forEach(function(t){var n=t.command,r=o[n];r&&(e[n]=r,delete o[n])}),this.empty()}}t.a=r},function(e,t,n){"use strict";function r(){return o||(o=n.e(4).then(function(t){var r=n(2).default;return e.controls=r,r}.bind(null,n)).catch(function(){o=null,Object(i.b)()})),o}n.d(t,"b",function(){return e}),t.a=r;var i=n(8),o=null,e={}},function(e,t,n){"use strict";var r=n(4),i=n(10),o=n(39),a=n(6),u=n(7),c=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},s=function(){function e(e){try{var a,u=e.responseXML?e.responseXML.childNodes:null,s="";if(u){for(var l=0;l<u.length&&(s=u[l],8===s.nodeType);l++);if("xml"===Object(i.b)(s)&&(s=s.nextSibling),"rss"===Object(i.b)(s)){var f=Object(o.a)(s);a=c({playlist:f},f.feedData)}}if(!a)try{var d=JSON.parse(e.responseText);if(Array.isArray(d))a={playlist:d};else{if(!Array.isArray(d.playlist))throw Error;a=d}}catch(e){throw new Error("Not a valid RSS/JSON feed")}n.trigger(r.U,a)}catch(e){t(e.message)}}function t(e){n.trigger(r.q,{message:e||"Error loading file"})}var n=c(this,u.a);this.load=function(n){a.a.ajax(n,e,t)},this.destroy=function(){this.off()}};t.a=s},function(e,t,n){"use strict";var r=n(7),i={on:r.a.on,once:r.a.once,off:r.a.off,trigger:r.a.trigger,get:function(e){return this.attributes=this.attributes||{},this.attributes[e]},set:function(e,t){if(this.attributes=this.attributes||{},this.attributes[e]!==t){var n=this.attributes[e];this.attributes[e]=t,this.trigger("change:"+e,this,t,n)}},clone:function(){var e={},t=this.attributes;if(t)for(var n in t)e[n]=t[n];return e},change:function(e,t,n){this.on("change:"+e,t,n);var r=this.get(e);return t.call(n,this,r,r),this}};t.a=i},function(e,t,n){"use strict";n.d(t,"a",function(){return i});var r=n(4),i={item:0,itemMeta:{},playlistItem:void 0,state:r._3,flashBlocked:!1,provider:void 0,duration:0,position:0,buffer:0}},function(e,t,n){"use strict";function r(e){var t=null;return e&&(t=e.querySelector("video, audio")),t||(t=document.createElement("video")),t.className="jw-video jw-reset",t}t.a=r},function(e,t,n){"use strict";function r(e){var t=document.createElement("a"),n=document.createElement("a");t.href=location.href;try{return n.href=e,n.href=n.href,t.protocol+"//"+t.host!=n.protocol+"//"+n.host}catch(e){}return!0}function i(e,t,n,i){d.a.isObject(e)&&(i=e,e=i.url);var s,l=p({xhr:null,url:e,withCredentials:!1,retryWithoutCredentials:!1,timeout:6e4,timeoutId:-1,oncomplete:t||v,onerror:n||v,mimeType:i&&!i.responseType?"text/xml":"",requireValidXML:!1,responseType:i&&i.plainText?"text":""},i);if("XDomainRequest"in window&&r(e))s=l.xhr=new window.XDomainRequest,s.onload=c(l),s.ontimeout=s.onprogress=v,h=!0;else{if(!("XMLHttpRequest"in window))return void l.onerror("",e);s=l.xhr=new window.XMLHttpRequest,s.onreadystatechange=u(l)}var f=a("Error loading file",l);s.onerror=f,"overrideMimeType"in s?l.mimeType&&s.overrideMimeType(l.mimeType):h=!0;try{e=e.replace(/#.*$/,""),s.open("GET",e,!0)}catch(e){return f(e),s}if(l.responseType)try{s.responseType=l.responseType}catch(e){}l.timeout&&(l.timeoutId=setTimeout(function(){o(s),l.onerror("Timeout",e,s)},l.timeout),s.onabort=function(){clearTimeout(l.timeoutId)});try{l.withCredentials&&"withCredentials"in s&&(s.withCredentials=!0),s.send()}catch(e){f(e)}return s}function o(e){e.onload=null,e.onprogress=null,e.onreadystatechange=null,e.onerror=null,"abort"in e&&e.abort()}function a(e,t){return function(n){var r=n.currentTarget||t.xhr;if(clearTimeout(t.timeoutId),t.retryWithoutCredentials&&t.xhr.withCredentials){o(r);return void i(p({},t,{xhr:null,withCredentials:!1,retryWithoutCredentials:!1}))}t.onerror(e,t.url,r)}}function u(e){return function(t){var n=t.currentTarget||e.xhr;if(4===n.readyState){if(clearTimeout(e.timeoutId),n.status>=400){var r;return r=404===n.status?"File not found":n.status+"("+n.statusText+")",e.onerror(r,e.url,n)}if(200===n.status)return c(e)(t)}}}function c(e){return function(t){var n=t.currentTarget||e.xhr;if(clearTimeout(e.timeoutId),e.responseType){if("json"===e.responseType)return s(n,e)}else{var r,i=n.responseXML;if(i)try{r=i.firstChild}catch(e){}if(i&&r)return l(n,i,e);if(h&&n.responseText&&!i&&(i=Object(f.parseXML)(n.responseText))&&i.firstChild)return l(n,i,e);if(e.requireValidXML)return void e.onerror("Invalid XML",e.url,n)}e.oncomplete(n)}}function s(e,t){if(!e.response||d.a.isString(e.response)&&'"'!==e.responseText.substr(1))try{e=p({},e,{response:JSON.parse(e.responseText)})}catch(n){return void t.onerror("Invalid JSON",t.url,e)}return t.oncomplete(e)}function l(e,t,n){var r=t.documentElement;return n.requireValidXML&&("parsererror"===r.nodeName||r.getElementsByTagName("parsererror").length)?void n.onerror("Invalid XML",n.url,e):(e.responseXML||(e=p({},e,{responseXML:t})),n.oncomplete(e))}t.b=r,t.a=i;var f=n(13),d=n(0),p=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},v=function(){},h=!1},function(e,t,n){"use strict";function r(e){return"hls"===e.type&&i.OS.android?!1!==e.androidhls&&(!i.Browser.firefox&&parseFloat(i.OS.version.version)>=4.4):null}t.a=r;var i=n(14)},function(e,t,n){"use strict";function r(e,t){var n=new y.a(t);return n.on(b.X,function(t){e._qoe.tick("ready"),t.setupTime=e._qoe.between("setup","ready")}),n.on("all",function(t,n){e.trigger(t,n)}),n}function i(e,t){e.off(),t.playerDestroy()}function o(e){for(var t=s.a.length;t--;)if(s.a[t].uniqueId===e.uniqueId){s.a.splice(t,1);break}}function a(e){var t=++x,n=e.id,a=new w.a,u={},c=r(this,e);a.tick("init"),Object.defineProperties(this,{id:{get:function(){return n}},uniqueId:{get:function(){return t}},plugins:{get:function(){return u}},_qoe:{get:function(){return a}},version:{get:function(){return h.a}},Events:{get:function(){return j.a}},utils:{get:function(){return O.a}},_:{get:function(){return k.a}}}),C(this,{_events:{},setup:function(t){return a.clear("ready"),a.tick("setup"),i(this,c),c=r(this,e),t.id=n,c.init(t,this),this.on(t.events,null,this)},remove:function(){return o(this),this.trigger("remove"),i(this,c),this},qoe:function(){var e=c.getItemQoe();return{setupTime:this._qoe.between("setup","ready"),firstFrame:e.getFirstFrame?e.getFirstFrame():null,player:this._qoe.dump(),item:e.dump()}},getAudioTracks:function(){return c.getAudioTracks()},getBuffer:function(){return c.get("buffer")},getCaptions:function(){return c.get("captions")},getCaptionsList:function(){return c.getCaptionsList()},getConfig:function(){return c.getConfig()},getContainer:function(){return c.getContainer()},getControls:function(){return c.get("controls")},getCurrentAudioTrack:function(){return c.getCurrentAudioTrack()},getCurrentCaptions:function(){return c.getCurrentCaptions()},getCurrentQuality:function(){return c.getCurrentQuality()},getDuration:function(){return c.get("duration")},getEnvironment:function(){return g},getFullscreen:function(){return c.get("fullscreen")},getHeight:function(){return c.getHeight()},getItemMeta:function(){return c.get("itemMeta")||{}},getMute:function(){return c.getMute()},getPlaybackRate:function(){return c.get("playbackRate")},getPlaylist:function(){return c.get("playlist")},getPlaylistIndex:function(){return c.get("item")},getPlaylistItem:function(e){if(!O.a.exists(e))return c.get("playlistItem");var t=this.getPlaylist();return t?t[e]:null},getPosition:function(){return c.get("position")},getProvider:function(){return c.getProvider()},getQualityLevels:function(){return c.getQualityLevels()},getSafeRegion:function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];return c.getSafeRegion(e)},getState:function(){return c.getState()},getStretching:function(){return c.get("stretching")},getViewable:function(){return c.get("viewable")},getVisualQuality:function(){return c.getVisualQuality()},getVolume:function(){return c.get("volume")},getWidth:function(){return c.getWidth()},setCaptions:function(e){return c.setCaptions(e),this},setConfig:function(e){return c.setConfig(e),this},setControls:function(e){return c.setControls(e),this},setCurrentAudioTrack:function(e){c.setCurrentAudioTrack(e)},setCurrentCaptions:function(e){c.setCurrentCaptions(e)},setCurrentQuality:function(e){c.setCurrentQuality(e)},setFullscreen:function(e){return c.setFullscreen(e),this},setMute:function(e){return c.setMute(e),this},setPlaybackRate:function(e){return c.setPlaybackRate(e),this},setCues:function(e){return c.setCues(e),this},setVolume:function(e){return c.setVolume(e),this},load:function(e,t){return c.load(e,t),this},play:function(e){return c.play(e),this},pause:function(e){return c.pause(e),this},playToggle:function(e){switch(this.getState()){case b._6:case b._0:this.pause(e);break;default:this.play(e)}},seek:function(e,t){return c.seek(e,t),this},playlistItem:function(e,t){return c.playlistItem(e,t),this},playlistNext:function(e){return c.playlistNext(e),this},playlistPrev:function(e){return c.playlistPrev(e),this},next:function(){return c.next(),this},castToggle:function(){return c.castToggle(),this},createInstream:function(){return c.createInstream()},skipAd:function(){return c.skipAd(),this},stop:function(){return c.stop(),this},resize:function(e,t){return c.resize(e,t),this},addButton:function(e,t,n,r,i){return c.addButton(e,t,n,r,i),this},removeButton:function(e){return c.removeButton(e),this},attachMedia:function(){return c.attachMedia(),this},detachMedia:function(){return c.detachMedia(),this},isBeforeComplete:function(){return c.isBeforeComplete()},isBeforePlay:function(){return c.isBeforePlay()}})}function u(e){for(var t=0;t<s.a.length;t++)if(s.a[t].id===e)return s.a[t];return null}Object.defineProperty(t,"__esModule",{value:!0});var c=n(16),s=n(27),l=n(17),f=n(18),d={availableProviders:l.a,registerProvider:f.a},p=n(23);d.registerPlugin=function(e,t,n){"jwpsrv"!==e&&Object(p.b)(e,t,n)};var v=d,h=n(20),m=n(19),g=n(14),y=n(45),b=n(4),w=n(21),j=n(7),O=n(6),k=n(0),C=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},x=0;C(a.prototype,{on:function(e,t,n){return j.c.call(this,e,t,n)},once:function(e,t,n){return j.d.call(this,e,t,n)},off:function(e,t,n){return j.b.call(this,e,t,n)},trigger:function(e,t){return t=k.a.isObject(t)?C({},t):{},t.type=e,m.a.debug?j.e.call(this,e,t):j.f.call(this,e,t)},getPlugin:function(e){return this.plugins[e]},addPlugin:function(e,t){this.plugins[e]=t,this.on("ready",t.addToPlayer),t.resize&&this.on("resize",t.resizeHandler)},registerPlugin:function(e,t,n){Object(p.b)(e,t,n)},getAdBlock:function(){return!1},playAd:function(e){},pauseAd:function(e){}}),n.p=Object(c.loadFrom)();var P=function(e){var t=void 0,n=void 0;if(e?"string"==typeof e?(t=u(e))||(n=document.getElementById(e)):"number"==typeof e?t=s.a[e]:e.nodeType&&(n=e,t=u(n.id)):t=s.a[0],t)return t;if(n){var r=new a(n);return s.a.push(r),r}return{registerPlugin:v.registerPlugin}};Object.defineProperties(P,{api:{get:function(){return v},set:function(){}},version:{get:function(){return h.a},set:function(){}},debug:{get:function(){return m.a.debug},set:function(e){m.a.debug=!!e}}});var E=P,S=n(40),T=n(36),_=n(22),M=n(37),N=n(39),L=n(34),A=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},F=k.a.extend,I={};I.api=v,I._=k.a,I.version="8.0.10+commercial_v8-0-10.220.commercial.f0e723.hlsjs..jwplayer.2df85c.dai.c13f11.freewheel.01885d.googima.534335.vast.5ded3a.jwpsrv.32f990.gapro.692829.related.eac442.vr.2cfb26",I.utils=A(O.a,{key:T.a,extend:F,scriptloader:_.a,rssparser:{parse:N.a},tea:M.a,UI:S.a}),I.utils.css.style=I.utils.style,I.vid=L.a;var R=I,B=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},q=window;B(E,R),"function"==typeof q.define&&q.define.amd&&q.define([],function(){return E});var D=E;q.jwplayer&&(D=q.jwplayer);t.default=D}]).default;

/***/ }),

/***/ "BEQ0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ "DuR2":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "FZ+f":
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),

/***/ "M3OJ":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("9a4R");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("MTIv")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../node_modules/css-loader/index.js!./player.css", function() {
			var newContent = require("!!../node_modules/css-loader/index.js!./player.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "MTIv":
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			memo[selector] = fn.call(this, selector);
		}

		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__("mJPh");

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),

/***/ "RQgh":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["Player"] = __webpack_require__("Y3Ya");
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "T8zW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "jwplayer.flash.swf";

/***/ }),

/***/ "Y3Ya":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _lodash = __webpack_require__("y1vT");

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__("T8zW");

__webpack_require__("M3OJ");

__webpack_require__("BBD6");

var _errorCodes = __webpack_require__("ouIc");

var _errorCodes2 = _interopRequireDefault(_errorCodes);

var _helpers = __webpack_require__("cX0o");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * # Player
                                                                                                                                                           *
                                                                                                                                                           * This is the Animoto wrapper for JW Player.  It exposes the 'Player' Class
                                                                                                                                                           *
                                                                                                                                                           * @requires jwPlayer
                                                                                                                                                           */
/*
  The JWPlayer SWF and Animoto css files for styling the player are required here
  so that they can be packaged and deployed properly by webpack
*/

/*
  The JWPlayer javascript is imported and assigned to the jwplayer variable
*/


var Player = function () {
  /**
   * Constructor for the Player class.  Takes in the element and options
   * and instantiates a JWPlayer object on that element
   *
   * @method constructor
   *
   * @param  {String}  playerElementId   The ID of the element on the page in which to instantiate the player
   * @param  {Object}  videoOptions      All of the options necessary to instantiate the player (playlist, cover image, etc.)
   *
   * @example
   *  var somePlayer = new Player('player-element-id', {
   *    playlist: [{
   *      image: 'https://s3.amazonaws.com/s3-p.animoto.com/Video/WMsbHDPVQetrRdVDhezlbg/cover_1920x1080.jpg',
   *      sources: [{
   *        file      : 'https://s3.amazonaws.com/s3-p.animoto.com/Video/9RXZ4u2JRm9pwGO9LtPccg/360p.mp4',
   *        label     : '1080p',
   *        'default' : true
   *      }]
   *    }],
   *    ctaSettings : {
   *      title : 'This is my CTA title',
   *      url   : 'http://www.animoto.com'
   *    },
   *    eventHandlers : {
   *      INITIALIZED : function(playerType) { console.log(playerType + ' was initialized'); },
   *      STARTED     : function(playerType) { console.log(playerType + ' started playing'); },
   *      COMPLETED   : function(playerType) { console.log(playerType + ' finished playing'); },
   *    },
   *    qosTracker : 'fake-domain.com/qos_trail.gif',
   *    qosStyle   : 'animoto_original',
   *    repeat     : false
   *    autostart  : false,
   *    mute       : false
   *  });
   *
   */
  function Player(playerElementId, videoOptions) {
    var _this = this;

    _classCallCheck(this, Player);

    var defaults = {
      allowPlaylistSorting: true,
      aspectratio: '16:9',
      width: '100%',
      key: 'x1HV1DwUcPxvBsl28p8l85EWfnZuK1P7In6bCZTj4osw1giS',
      flashplayer: '//d150hyw1dtprld.cloudfront.net/player/77f9abc9c2798b7a9c7678214dd3cf55db3285b6/jwplayer.flash.swf',
      preload: 'none',
      skin: {
        active: '#1bcdcf',
        inactive: '#eeeeee',
        controlbar: {
          text: '#eeeeee',
          icons: '#eeeeee',
          iconsActive: '#1bcdcf'
        },
        tooltips: {
          text: '#505050'
        },
        menus: {
          background: 'rgba(51, 51, 51, 0.8)'
        }
      }
    };
    var setupOptions = Object.assign({}, defaults, videoOptions);

    this.uuid = (0, _helpers.uuidV4)();

    this.resetDefaultPlaybackQuality();

    this.originalSetupOpitions = setupOptions;
    this.playerElementId = playerElementId;

    this.setupPlayer(playerElementId, setupOptions);
    this.resetDefaultVolume(setupOptions.mute);

    // This error handler handles the scenario where an old animoto mp4 video
    // render with bad enconding is loaded by JWPlayer. This will default the
    // provider to flash to put the player into a playable state
    this.player.on('error', function (event) {
      var errorCode = _this.findErrorCodeByValue(event.message);
      if (errorCode === 'UNSUPPORTED_FILE_ENCODING' && _this.getProviderName() === 'html5') {
        _this.resetPlayer({ primary: 'flash' }, true);
      }
    });
  }

  /**
   * Instantiates a JWPlayer instance on an element calls setup on that instance.
   * Can be called multiple times on a player instance
   *
   * @method setupPlayer
   * @private
   *
   * @param  {String}  playerElementId   The ID of the element on the page in which to instantiate the player
   * @param  {Object}  setupOptions      All of the options necessary to instantiate the player (playlist, cover image, etc.)
   *
   * @example
   *   playerInstanceVariable.setupPlayer('player-element-id', {
   *    playlist: [{
   *      image: 'https://s3.amazonaws.com/s3-p.animoto.com/Video/WMsbHDPVQetrRdVDhezlbg/cover_1920x1080.jpg',
   *      sources: [{
   *        file      : 'https://s3.amazonaws.com/s3-p.animoto.com/Video/9RXZ4u2JRm9pwGO9LtPccg/360p.mp4',
   *        label     : '1080p',
   *        'default' : true
   *      }]
   *    }],
   *    ctaSettings : {
   *      title : 'This is my CTA title',
   *      url   : 'http://www.animoto.com'
   *    },
   *    eventHandlers : {
   *      INITIALIZED : function(playerType) { console.log(playerType + ' was initialized'); },
   *      STARTED     : function(playerType) { console.log(playerType + ' started playing'); },
   *      COMPLETED   : function(playerType) { console.log(playerType + ' finished playing'); },
   *    },
   *    qosTracker : 'fake-domain.com/qos_trail.gif',
   *    qosStyle   : 'animoto_original',
   *    repeat     : false
   *    autostart  : false,
   *    mute       : false
   *  });
   */


  Player.prototype.setupPlayer = function setupPlayer(playerElementId, setupOptions) {
    var _this2 = this;

    if (this.player) {
      this.player.remove();
    }

    this.player = window.jwplayer(playerElementId);

    if (setupOptions.playlist && setupOptions.allowPlaylistSorting) {
      this.sortPlaylistSources(setupOptions.playlist);
      this.setMinDvrWindowIfHLS(setupOptions.playlist);
    }

    this.player.setup(setupOptions);

    if (setupOptions.playlist) {
      this.seekReset(setupOptions.playlist);
    }

    if (setupOptions.eventHandlers) {
      this.bindHandlers(setupOptions.eventHandlers);
    }

    this.player.on('setupError', function () {
      document.getElementById(playerElementId).innerHTML = '<div class="jw-flash-required-message"><div class="jw-flash-header">Flash Player Required</div><div>Unfortunately we could not load the video player as it requires the Adobe Flash Player to be installed. Please <a href="http://get.adobe.com/flashplayer/" target="_blank" class="jw-flash-link">download the latest version</a>.</div></div>';
    });

    this.player.on('levelsChanged', function (event) {
      _this2.previousQualityLevelIndex = _this2.currentQualityLevelIndex;
      _this2.currentQualityLevelIndex = event.currentQuality;
    });

    this.player.on('ready', function () {
      var playlist = _this2.player.getPlaylist();
      var playlistSources = playlist[0] && playlist[0].sources;

      _this2.previousQualityLevelIndex = null;

      var currentQualityLevelIndex = _this2.currentQualityLevelIndex > -1 ? _this2.currentQualityLevelIndex : _this2.player.getCurrentQuality();
      var filteredSource = void 0;

      if (currentQualityLevelIndex < 0) {
        filteredSource = playlistSources.filter(function (source) {
          return source.default;
        });
        currentQualityLevelIndex = playlistSources.indexOf(filteredSource[0]);
      }
      _this2.currentQualityLevelIndex = Math.max(currentQualityLevelIndex, 0);

      if (_this2.isHLS()) {
        var playerElement = document.getElementById(playerElementId);
        playerElement.classList.add('is-hls');

        var buttonContainerElement = playerElement.getElementsByClassName('jw-button-container')[0];
        if (buttonContainerElement) {
          var renderingMessageElement = document.createElement('h5');
          renderingMessageElement.id = 'renderingMessage';
          renderingMessageElement.className = 'hls-message';
          renderingMessageElement.innerHTML = 'Streaming';
          buttonContainerElement.appendChild(renderingMessageElement);
        }

        // The `.tooltip-time` element (scrub bar) is hidden for HLS mode because the progress bar
        // jumps around in a confusing way to users.  After the last chunk of the stream has been
        // loaded, however, the player switches to VOD mode.  The progress bar will then behave
        // predicably and can be shown, providing the user with the ability to scrub.
        //
        // I'm detecting this switch between HLS and VOD mode by looking for the duration to switch
        // between a negative to a positive, known value.
        var onTimeHandler = function onTimeHandler(obj) {
          if (obj.duration > 0) {
            // This means the player switched from HLS to VOD
            _this2.player.off('time', onTimeHandler);
            if (!playerElement.classList.contains('vod-mode')) {
              playerElement.classList.add('vod-mode');
            }
            var messageElement = document.getElementById('renderingMessage');
            if (messageElement) {
              messageElement.remove();
            }
          }
        };

        _this2.player.on('time', (0, _lodash2.default)(onTimeHandler, 300));
      }
    });

    // Because all seeks cause a play event in jwplayer, checking state of player
    // and then forcing it to pause if it was paused before the seek
    this.player.on('seek', function () {
      _this2.maintainPauseAfterSeek(_this2.player.getState());
    });

    // If there is a CTA set on the video
    if (setupOptions.ctaSettings) {
      this.setupCTA(setupOptions.ctaSettings);
    }

    if (setupOptions.qosTracker) {
      this.setupQOSBindings(setupOptions.qosTracker, setupOptions.qosStyle);
    }
  };

  /**
   * Resets player through calling of setupPlayer with opitional additional
   * setup options and allows for restarting of video playback
   *
   * @method resetPlayer
   *
   * @param {Object} additionalSetupOptions Additional setup options to merge into original setup options
   * @param {Boolean} shouldRestartPlayback Flag that determines whether to start playback once player is reset
   *
   */


  Player.prototype.resetPlayer = function resetPlayer(additionalSetupOptions, shouldRestartPlayback) {
    var _this3 = this;

    this.setupPlayer(this.playerElementId, Object.assign({}, this.originalSetupOpitions, additionalSetupOptions));
    if (shouldRestartPlayback) {
      this.player.once('ready', function () {
        _this3.player.play(true);
      });
    }
  };
  /**
   * Sort playlist sources by label so that player HD toggle active and inactive styles
   * are set properly depending on playlist source length
   *
   * @method sortPlaylistSources
   * @private
   *
   * @param  {Array} playlist Playist array with playlist items
   *
   * @example
   *   this.sortPlaylistSources([{
         image: 'https://s3.amazonaws.com/s3-p.animoto.com/Video/WMsbHDPVQetrRdVDhezlbg/cover_1920x1080.jpg',
         sources: [
          {
            file      : 'https://s3.amazonaws.com/s3-p.animoto.com/Video/9RXZ4u2JRm9pwGO9LtPccg/360p.mp4?t=720',
            label     : '720p'
          },
          {
            file      : 'https://s3.amazonaws.com/s3-p.animoto.com/Video/9RXZ4u2JRm9pwGO9LtPccg/360p.mp4',
            label     : '360p'
          },
          {
           file      : 'https://s3.amazonaws.com/s3-p.animoto.com/Video/9RXZ4u2JRm9pwGO9LtPccg/360p.mp4?t=480',
           label     : '480p',
           'default' : true
         }
       ]);
   */


  Player.prototype.sortPlaylistSources = function sortPlaylistSources(playlist) {
    playlist.forEach(function (item) {
      var sources = item.sources;

      if (sources.length > 2) {
        sources.sort(function (a, b) {
          return -a.label.localeCompare(b.label);
        });
      } else {
        sources.sort(function (a, b) {
          return a.label.localeCompare(b.label);
        });
      }
    });
  };

  /**
   * Set minDvrWindow for playlist item if the source is hls
   *
   * @method setMinDvrWindowIfHLS
   *
   * @param {Object} playlist - playlist object for player
   *
   */


  Player.prototype.setMinDvrWindowIfHLS = function setMinDvrWindowIfHLS(playlist) {
    playlist.forEach(function (item) {
      if (item.sources[0].file.indexOf('.m3u8') !== -1) {
        item.minDvrWindow = 0;
      }
    });
  };

  /**
   * Resets the seek to 0 when playing for hls to actually start at the beginning
   *
   * @method seekReset
   *
   * @param {Object} playlist - playlist object for player
   *
   */


  Player.prototype.seekReset = function seekReset(playlist) {
    var _this4 = this;

    var needsSeeking = playlist.some(function (item) {
      return item.sources[0].file.indexOf('.m3u8') !== -1;
    });

    if (needsSeeking) {
      this.player.once('play', function () {
        _this4.player.seek(0);
      });
    }
  };

  /**
   * Check if current playback file is HLS stream
   *
   * @method isHLS
   *
   * @returns {Boolean} Is current playback HLS stream
   *
   */


  Player.prototype.isHLS = function isHLS() {
    return this.getCurrentPlaybackFile().indexOf('.m3u8') !== -1;
  };

  /**
   * Get full path to current file being played
   *
   * @method getCurrentPlaybackFile
   *
   * @returns {String} Full path to playback file
   *
   */


  Player.prototype.getCurrentPlaybackFile = function getCurrentPlaybackFile() {
    var sources = this.player.getPlaylist()[0].sources;
    var currentPlaybackSource = sources[this.currentQualityLevelIndex || 0];
    var currentPlaybackFile = currentPlaybackSource && currentPlaybackSource.file;

    return currentPlaybackFile || '';
  };

  /**
   * Set the volume on the wrapped player instance
   *
   * @method setVolume
   *
   * @param  {Integer} volume      The volume level on a 0 - 100 scale
   *
   * @example
   *   playerInstanceVariable.setVolume(20);
   */


  Player.prototype.setVolume = function setVolume(volume) {
    this.player.setVolume(volume);
  };

  /**
   * Get the type of player being used (flash, html5, etc.)
   *
   * @method getProviderName
   *
   * @returns {String}  The type of provider currently being used for playback (html5, flash, etc.)
   *
   * @example
   *   var playerType = playerInstanceVariable.getProviderName();
   */


  Player.prototype.getProviderName = function getProviderName() {
    var provider = this.player.getProvider();
    return provider ? provider.name : '';
  };

  /**
   * Given an error message from JWPlayer returns an error code key
   *
   * @method findErrorCodeByValue
   * @private
   *
   * @param  {String} value Error message given by JWPlayer
   *
   * @returns {String} Key that maps to the value passed to function
   *
   * @example
   *   this.findErrorCodeByValue('Error loading player: Flash version must be 11.2 or greater');
   */


  Player.prototype.findErrorCodeByValue = function findErrorCodeByValue(value) {
    return Object.keys(_errorCodes2.default).find(function (key) {
      return _errorCodes2.default[key] === value;
    });
  };

  /**
   * Take the provided event handlers and bind them to the appropriate events triggered by JW Player
   * The event handler is always passed the value of getProviderName
   *
   * @method bindHandlers
   * @private
   *
   * @param  {Object} eventHandlers    An object where the keys are possible events, and the values are the callback
   *
   * @example
   *   this.bindHandlers({ INITIALIZED : function(playerType) { console.log('Player ready', playerType); } });
   */


  Player.prototype.bindHandlers = function bindHandlers(eventHandlers) {
    var _this5 = this;

    // Loop through the properties of the object
    Object.keys(eventHandlers).forEach(function (k) {
      var eventType = void 0;
      var eventHandler = void 0;

      switch (k) {
        case 'INITIALIZED':
          eventType = 'ready';
          eventHandler = _this5.bindHandler(eventHandlers[k]);
          break;
        case 'STARTED':
          eventType = 'play';
          eventHandler = _this5.bindHandler(eventHandlers[k]);
          break;
        case 'COMPLETED':
          eventType = 'complete';
          eventHandler = _this5.bindHandler(eventHandlers[k]);
          break;
        case 'SETUP_ERROR':
          eventType = 'setupError';
          eventHandler = _this5.bindErrorHandler(eventHandlers[k]);
          break;
        case 'ERROR':
          eventType = 'error';
          eventHandler = _this5.bindErrorHandler(eventHandlers[k]);
          break;
        case 'PLAYLIST_LOADED':
          eventType = 'playlist';
          eventHandler = _this5.bindHandler(eventHandlers[k]);
          break;
        case 'PROGRESS':
          eventType = 'time';
          eventHandler = _this5.bindHandler(eventHandlers[k]);
          break;
        case 'SEEKED':
          eventType = 'seeked';
          eventHandler = _this5.bindHandler(eventHandlers[k]);
          break;
        default:
          eventType = false;
      }

      if (eventType) {
        switch (eventType) {
          case 'ready':
          case 'play':
          case 'complete':
            _this5.player.once(eventType, eventHandler);
            break;
          default:
            _this5.player.on(eventType, eventHandler);
        }
      }
    });
  };

  /**
   * Recieves a function and binds this classes scope to it
   * The event handler is always passed the value of getProviderName
   *
   * @method bindHandler
   * @private
   *
   * @param {Function} handler A function that is an event handler
   *
   * @returns {Function} The passed in function wrapped in a function giving it this classes scope
   *
   * @example
   *   this.bindHandler(function(playerType) { console.log('Player ready', playerType); });
   */


  Player.prototype.bindHandler = function bindHandler(handler) {
    var _this6 = this;

    return function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      // Call the event handler with the player 'type'
      handler.apply(undefined, [_this6.getProviderName()].concat(args));
    };
  };

  /**
   * Recieves a function and binds this classes scope to it
   * The event handler is always passed the value of getProviderName
   * and the error code from errorCodes map
   *
   * @method bindErrorHandler
   * @private
   *
   * @param {Function} handler A function that is an event handler
   *
   * @returns {Function} The passed in function wrapped in a function giving it this classes scope
   *
   * @example
   *   this.bindErrorHandler(function(playerType, event, errorCode) { console.log('Player ready', playerType); });
   */


  Player.prototype.bindErrorHandler = function bindErrorHandler(handler) {
    var _this7 = this;

    return function (event) {
      var errorCode = _this7.findErrorCodeByValue(event.message);
      // Call the event handler with the player 'type' and error code
      handler(_this7.getProviderName(), event, errorCode);
    };
  };

  /**
   * Loads a new playlist into an existing Player instance. Also removes current
   * default playback quality so that the "default" flag playlist source item
   * is honored
   *
   * @method loadPlaylist
   * @public
   *
   * @param {Array} playlist Loads a new playlist into an existing Player instance
   *
   * @example
   *   playerInstanceVariable.loadPlaylist([{
   *   image: 'https://s3.amazonaws.com/s3-p.animoto.com/Video/WMsbHDPVQetrRdVDhezlbg/cover_1920x1080.jpg',
   *   sources: [
   *     {
   *       file      : 'https://s3.amazonaws.com/s3-p.animoto.com/Video/9RXZ4u2JRm9pwGO9LtPccg/720p.mp4',
   *       label     : '720p',
   *       'default' : true
   *     },
   *     {
   *      file      : 'https://s3.amazonaws.com/s3-p.animoto.com/Video/9RXZ4u2JRm9pwGO9LtPccg/360p.mp4',
   *      label     : '360p'
   *     }
   *    ]
   *  }]);
   */


  Player.prototype.loadPlaylist = function loadPlaylist(playlist) {
    this.resetDefaultPlaybackQuality();
    this.sortPlaylistSources(playlist);
    this.player.load(playlist);
    this.hideCTA();
  };

  /**
   * Returns the label of the current playback quality level
   *
   * @method getCurrentPlaybackQualityLabel
   * @public
   *
   * @returns {String} Current playback quality level
   *
   * @example
   *   this.getCurrentPlaybackQualityLabel();
   */


  Player.prototype.getCurrentPlaybackQualityLabel = function getCurrentPlaybackQualityLabel() {
    var qualityLevels = this.player.getQualityLevels();
    var currentQualityLevelIndex = this.currentQualityLevelIndex;

    return qualityLevels && qualityLevels.length > 0 && currentQualityLevelIndex >= 0 ? qualityLevels[currentQualityLevelIndex].label : null;
  };

  /**
   * Clears jwplayer localStorage variable which determines playback quality
   *
   * @method resetDefaultPlaybackQuality
   * @private
   *
   * @example
   *   this.resetDefaultPlaybackQuality();
   */


  Player.prototype.resetDefaultPlaybackQuality = function resetDefaultPlaybackQuality() {
    try {
      localStorage.removeItem('jwplayer.qualityLabel');
    } catch (e) {
      // localStorage is disabled
    }
  };

  /**
   * Resets volume and mute state to default values. JWPlayer
   * keeps state of both in local storage between player instances.
   *
   * @method resetDefaultVolume
   * @private
   *
   * @param {Boolean} muteValue Mute value to set on the player
   *
   * @example
   *   this.resetDefaultVolume();
   */


  Player.prototype.resetDefaultVolume = function resetDefaultVolume() {
    var muteValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    this.player.setVolume(90);
    this.player.setMute(muteValue);
  };

  /**
   * Sets up a one time event listener for the "seeked" event to pause
   * the player if it was paused before seeking
   *
   * @method maintainPauseAfterSeek
   * @private
   *
   * @param {String} playState The play state on seeking
   *
   * @example
   *   this.maintainPauseAfterSeek('paused');
   */


  Player.prototype.maintainPauseAfterSeek = function maintainPauseAfterSeek(playState) {
    var _this8 = this;

    if (playState === 'paused') {
      this.player.once('seeked', function () {
        _this8.player.pause();
      });
    }
  };

  /**
   * Seeks player to the point it was at before loading new playlist
   *
   * @method keepPlayPositionAfterPlaylistLoad
   * @public
   *
   * @param {String} preLoadPlayState The play state before loading playlist
   *
   * @example
   *   this.keepPlayPositionAfterPlaylistLoad('paused');
   */


  Player.prototype.keepPlayPositionAfterPlaylistLoad = function keepPlayPositionAfterPlaylistLoad(preLoadPlayState) {
    var _this9 = this;

    var position = this.player.getPosition();

    this.player.once('playlistItem', function () {
      _this9.maintainPauseAfterSeek(preLoadPlayState);
      if (position > 0) {
        _this9.player.seek(position);
      }
    });
  };

  /* ***********************************************************************************************
   *  CTA Related Functionality
   ** **********************************************************************************************/
  /**
   * Setup all of the CTA functionality
   *
   * @method setupCTA
   * @private
   *
   * @param  {Object} ctaSettings    An object containing the cta label and url
   *
   * @example
   *   this.setupCTA({ title : 'CTA Title', url : 'www.google.com' });
   */


  Player.prototype.setupCTA = function setupCTA(ctaSettings) {
    var _this10 = this;

    this.createCTA(ctaSettings);
    this.player.on('play', function () {
      _this10.hideCTA();
    });
    this.player.on('pause', function () {
      _this10.showCTA();
    });
    this.player.on('complete', function () {
      _this10.showCTA();
    });
  };

  /**
   * Take the CTA settings and create the appropriate HTML element, storing it on the class instance
   *
   * @method createCTA
   * @private
   *
   * @param  {Object} ctaSettings    An object containing the cta label and url
   *
   * @example
   *   this.createCTA({ title : 'CTA Title', url : 'www.google.com' });
   */


  Player.prototype.createCTA = function createCTA(ctaSettings) {
    var url = ctaSettings.url;

    // Ensure that if the CTA didn't have a protocol, to default to basic http
    if (url.indexOf('://') === -1 && url.toLowerCase().indexOf('mailto:') === -1) {
      url = 'http://' + url;
    }

    this.ctaElement = document.createElement('a');
    this.ctaElement.innerHTML = ctaSettings.title;
    this.ctaElement.setAttribute('href', url);
    this.ctaElement.setAttribute('target', '_blank');
    this.ctaElement.className = 'player_cta';
  };

  /**
   * Append the CTA element to the DOM to make it visible
   *
   * @method showCTA
   * @private
   *
   * @example
   *   this.showCTA();
   */


  Player.prototype.showCTA = function showCTA() {
    if (this.ctaElement && !this.ctaElement.parentNode) {
      document.getElementById(this.playerElementId).appendChild(this.ctaElement);
    }
  };

  /**
   * Remove the CTA element from the DOM
   *
   * @method hideCTA
   * @private
   *
   * @example
   *   this.hideCTA();
   */


  Player.prototype.hideCTA = function hideCTA() {
    if (this.ctaElement && this.ctaElement.parentNode) {
      this.ctaElement.parentNode.removeChild(this.ctaElement);
    }
  };

  /* ***********************************************************************************************
   *  Quality of Service Tracking Related Functionality
   ** **********************************************************************************************/

  /**
   * @method setupQOSBindings
   * @private
   *
   * @param  {String} qosTracker    The url of the tracking pixel to insert into the page
   * @param  {String} qosStyle      (Optional) Style name of the video being played
   *
   * @example
   *   this.setupQOSBindings('https://animoto.com/trail.gif');
   */


  Player.prototype.setupQOSBindings = function setupQOSBindings(qosTracker) {
    var _this11 = this;

    var qosStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    this.player.on('buffer', function (details) {
      _this11.loadCustomPixel(_this11.trackingUrl(qosTracker, 'buffering', {
        ps: details.oldstate,
        cs: details.newstate,
        r: details.reason,
        sn: qosStyle
      }));
    });
    this.player.once('firstFrame', function (details) {
      _this11.loadCustomPixel(_this11.trackingUrl(qosTracker, 'firstFrame', {
        ttff: details.loadTime,
        sn: qosStyle
      }));
    });
    this.player.on('levelsChanged', function (event) {
      var qualityLevels = _this11.player.getQualityLevels();
      var oldQuality = qualityLevels.length > 0 && qualityLevels[_this11.previousQualityLevelIndex];
      var newQuality = qualityLevels.length > 0 && qualityLevels[event.currentQuality];

      _this11.loadCustomPixel(_this11.trackingUrl(qosTracker, 'levelsChanged', {
        pq: oldQuality && oldQuality.label,
        cq: newQuality && newQuality.label
      }));
    });
  };

  /**
   * Inserts an image into the page to allow for tracking.  The CSS ensures the pixel isn't displayed
   *
   * @method loadCustomPixel
   * @private
   *
   * @param  {String} url    The url of the tracking pixel to insert into the page
   *
   * @example
   *   this.loadCustomPixel('https://animoto.com/trail.gif?tracking=thing');
   */


  Player.prototype.loadCustomPixel = function loadCustomPixel(url) {
    var pixel = document.createElement('img');
    pixel.className = 'player_qos_tracking_pixel';
    pixel.setAttribute('src', url);
    pixel.setAttribute('alt', '');
    document.getElementById(this.playerElementId).appendChild(pixel);
  };

  /**
   * Returns okey of a file given a video or stream file url
   *
   * @method getOkeyFromFileURL
   * @private
   *
   * @param  {String} fileUrl File url of a video or stream
   *
   * @returns {String} The okey contained in file url
   *
   * @example
   *   var okey = this.getOkeyFromFileURL('https://s3.amazonaws.com/s3-s.animoto.com/Stream/MzUCXRIc6cAAq27QPu2Chg/hls.360p15.m3u8');
   */


  Player.prototype.getOkeyFromFileURL = function getOkeyFromFileURL(fileUrl) {
    var regEx = /\/(?:Video|Stream)\/(.+)\//;
    var matches = regEx.exec(fileUrl);

    return matches.length > 1 ? matches[1] : '';
  };

  /**
   * Forms the url of the pixel to load to track all of the data for the fired event
   *
   * @method trackingUrl
   * @private
   *
   * @param  {String} qosTracker      The url of the tracking pixel to insert into the page
   * @param  {String} eventType       The type of event that is being tracked
   * @param  {Object} additionalData  Any additional data specific to this event provided by the handler
   *
   * @returns {String}  The generated url including all of the data to be tracked
   *
   * @example
   *   var trackUrl = this.trackingUrl('https://animoto.com/trail.gif', 'start', {});
   */


  Player.prototype.trackingUrl = function trackingUrl(qosTracker, eventType, additionalData) {
    var currentPlaybackFile = this.getCurrentPlaybackFile();

    var url = '//' + qosTracker;

    url += '?s=player_qos_v1' + // eslint-disable-line prefer-template, scope
    '&e=' + eventType + // event
    '&src=' + document.location.hostname + // source
    '&pt=' + this.getProviderName() + // player type
    '&t=' + Math.round(new Date().getTime() / 1000) + // time of event
    '&file=' + encodeURIComponent(currentPlaybackFile) + // current file
    '&okey=' + this.getOkeyFromFileURL(currentPlaybackFile) + // current okey
    '&res=' + this.getCurrentPlaybackQualityLabel() + // current resolution
    '&p=' + this.player.getPosition() + // playhead position
    '&d=' + this.player.getDuration() + '&uuid=' + this.uuid;

    if (additionalData) {
      Object.keys(additionalData).forEach(function (k) {
        url += '&' + encodeURIComponent(k) + '=' + encodeURIComponent(additionalData[k]);
      });
    }

    return url;
  };

  /**
   * Removes JPlayer instance and CTA DOM
   *
   * @method destroy
   * @public
   *
   * @example
   *   playerInstance.destroy();
   */


  Player.prototype.destroy = function destroy() {
    this.hideCTA();
    this.player.remove();
  };

  return Player;
}();

exports.default = Player;
module.exports = exports['default'];

/***/ }),

/***/ "aN+w":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _objectAssign = __webpack_require__("BEQ0");

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Object.assign = _objectAssign2.default;

/***/ }),

/***/ "cX0o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.uuidV4 = uuidV4;
/* eslint-disable */
var CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');

/**
 * Returns a universally unique identifier that conforms
 * to RFC4122 v4 proto (https://tools.ietf.org/html/rfc4122)
 *
 * @method uuidV4
 * @public
 *
 * @returns {String} RFC4122 v4 UUID
 *
 */
function uuidV4() {
  var chars = CHARS,
      uuid = new Array(36);

  var rnd = 0,
      r = void 0;

  for (var i = 0; i < 36; i++) {
    if (i === 8 || i === 13 || i === 18 || i === 23) {
      uuid[i] = '-';
    } else if (i === 14) {
      uuid[i] = '4';
    } else {
      if (rnd <= 0x02) rnd = 0x2000000 + Math.random() * 0x1000000 | 0;
      r = rnd & 0xf;
      rnd >>= 4;
      uuid[i] = chars[i === 19 ? r & 0x3 | 0x8 : r];
    }
  }
  return uuid.join('');
}

/***/ }),

/***/ "mJPh":
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),

/***/ "ouIc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = {
  INVALID_FLASH_VERSION: 'Error loading player: Flash version must be 11.2 or greater',
  UNSUPPORTED_FILE_ENCODING: 'Error loading media: File could not be played'
};
module.exports = exports['default'];

/***/ }),

/***/ "y1vT":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ })

/******/ });


// WEBPACK FOOTER //
// player-bundle.js